function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateACoalition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 720,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M0 0L0 166L44.0247 177.921L88 168C91.7298 181.854 110.933 179.57 122 179.571C156.835 179.573 191.304 181.716 226 181L227 185C221.529 188.514 218.065 194.535 212.996 198.62C204.353 205.586 194.316 209.483 186.844 218.167C180.208 225.879 177.075 236.325 169.787 243.561C148.947 264.251 128.621 284.615 108.551 306.13C95.2024 320.439 81.1806 334.212 76.5949 354C72.3535 372.303 84.6775 382.674 94.4545 395.104C98.5953 400.369 101.058 406.765 105.761 411.711C120.515 427.226 139.636 441.627 158.004 452.691C167.72 458.543 182.16 468.343 194 467L194 465L184 464C183.664 457.093 170.327 451.389 165.019 447.912C155.333 441.568 148.06 433.306 139.715 425.473C135.453 421.473 129.523 419.327 125.803 414.675C120.795 408.412 117.035 395.674 110 392C112.012 383.451 109.443 370.303 106.161 362.184C104.294 357.565 100.65 354.353 100.263 349.015C99.8267 342.992 105.525 335.503 108.986 330.986C117.967 319.266 124.904 309.399 138 302C141.99 309.296 149.558 309.887 152 301L160 301L160 309L164 304L168 304L174 288L170 287L170 283C179.949 278.932 189.329 276.978 200 277L200 274L216 278L216.042 320.999L212.808 332.039L208 379L218 372C221.587 363.83 228.158 364.528 234.485 359.197C238.884 355.491 238.831 350.156 242 346L242 345L242 344L240 340L243 340L243 336L237 336L240 328C245.249 328 256.387 330.135 260 326L261 326C262.636 328.913 264.823 325.903 262 326L266 320L240 325L248.427 311.576L249.286 303.213L261 296L262 304C267.412 303.582 269.321 300.414 272 296C267.707 293.626 267.937 290.502 272 288C273.175 295.844 275.173 303.895 284 304L288 324C293.247 321.671 290.846 305.038 286 304C288.253 298.886 287.263 289.83 281 288L281 280L285 278L296 285C296.461 290.939 301.58 293.581 307 295L307 296C302.784 301.197 313.078 310.986 318 312C316.9 319.441 323.373 325.096 325.483 332C330.518 348.47 336.263 368.607 335 386L336 386L336 384L337 384L339.275 426L335.423 445.941L344.852 455.019L345 515L346 515L346 464L347 464L347 480L350 480L351 458L352 458L352 467L353 467C361.81 454.348 358.81 437.88 357.376 424C356.119 411.833 355.607 400.103 353.464 388C350.311 370.197 353.23 351.348 347.151 334C339.229 311.39 328.924 288.935 319.316 267C315.873 259.14 310.747 252.288 307.938 244C304.978 235.266 305.596 225.946 303.714 217C300.462 201.544 296.601 181.391 302.559 166.004C307.48 153.292 317.66 148.233 326.412 138.968C330.774 134.351 330.29 127.463 336 123L342 136L345 134C347.11 145.363 341.082 147.493 336.938 157C334.964 161.527 335.237 167.211 333.907 172C330.654 183.719 325.93 189.141 329 202C323.953 206.241 321.748 225.481 327 230L336 256C343.151 259.64 344.04 267.539 347.676 274C358.362 292.987 366.844 313.496 364 336L368 336C369.609 332.78 372.694 329.905 372.471 326.039C371.837 315.071 359.067 304.054 365.572 292.014C374.586 275.329 390.904 273.703 406 282.179C408.944 283.832 416.771 287.485 417.369 291.191C417.983 294.997 410.827 298.068 409.873 302.005C407.67 311.1 414.688 324.425 419 332L420 332C419.96 327.501 419.859 322.842 416 320L416 302L424 297C426.294 287.146 443.817 294.064 449 297.199C464.865 306.796 477.382 320.144 489.31 334.005C492.211 337.375 493.689 342.477 496.806 345.5C499.264 347.885 503.679 345.379 506 344L505 351L505 352L511 354L512 350L509 349L509 348L513 348L513 347L507 345L520 345L520 347L516 347L519 356L523 355L524 344L528 348L530 349L531 349L532 344L535 345C535 341.019 546.419 340.283 550 340L550 339L545 338L545 337L559.701 337.012L567.015 342.595L584 345L582 344L582 345L602 340L602 346L603 346L605 341L612 338L613 338L613 344L624 328L627 321L626 328L627 328L628 322C631.408 327.06 628.948 330.49 628 336C641.279 331.65 636.316 310.359 654 313L655 310L656 310L651 333L652 333L653 328L654 328L654 331L655 331L658 323C654.605 323 657.481 320.983 659 320L658 322L662 321L662 320L659 320L660 317C653.544 316.151 662.423 305.213 663 302L667 303L667 302L665 302L665 301L671 301L671 300L668 300L668 299L669 297L671 294L676 297L676 296C674.04 295.347 673.446 295 676 295L676 294L673 295L673 291L679 291L677 295C684.217 287.268 661.742 289.676 658 290L659 284L662 282L661 278L662 278L663 280L665 275L665 274L662 273L666 267L654 267L664 260L660 254L656 257L659 252L661 253L662 245L661 245L658 247L663 236L675 234L674 244L666 241L667 245C676.922 244.321 677.558 242.52 683 235L676 233L685 233L689 229C687.651 224.933 686.318 223.497 682 223L682 219L685 220L688 215C683.692 210.457 689.169 204.073 691 199L689 193L688 193L686 199L688 198C684.068 201.803 680.145 202.223 675 201L680 192C684.446 192.295 687.232 190.476 688 186L697 185L697 184L693 185L700 180L700 179L704 173L700 171C708.04 165.618 702.901 159.295 706.136 152C709.479 144.46 716.865 140.68 718 132C728.052 131.479 732.257 124.955 739.114 118.843C749.066 109.974 759.024 102.346 773 103L772 99L782 96L782 97L776 101L776 102L783 97L784 97L784 100L785 100L785 94L788 97L792 93C792.647 96.9118 797.839 92.0137 800.018 91.0833C807.844 87.743 819.731 87.5427 828 88.7454C854.451 92.5926 872.599 106.533 878.644 133C880.099 139.375 883.751 156.034 876.843 160.444C872.826 163.009 865.598 155.557 860 157C864.177 163.673 870.817 169.241 873.362 177C876.272 185.873 873.289 196.75 874.17 206C876.232 227.671 882.822 251.197 879.791 273C878.903 279.388 877.933 288.143 875.291 294C871.25 302.959 864.262 309.424 866 320C887.933 320 908.009 320.715 929 327.559C937.33 330.276 948.038 334.357 950 344C955.503 344.37 958.854 346.441 960 352C964.924 352.688 967.267 355.09 968 360L969 360C974.573 351.608 977.801 341.159 987 336L991.74 322.999L992 293L993 293L996 304L1000 304C1000.04 314.893 1000.34 323.016 1008 330L1009 330L1010 330C1022.15 308.355 1024.15 285.71 1030.04 262C1033.31 248.781 1039.01 237.969 1040 224L1043 224L1049.74 173.83L1052.46 146.171L1066.56 96L1059.16 67L1064 48C1076.91 43.3139 1065.98 29.392 1064.12 22C1061.77 12.6741 1066.68 6.14655 1074 1L1074 0C1068.27 0 1053.04 -2.70844 1049.3 2.31409C1044.64 8.56207 1042.3 16.4504 1041.54 24C1041.33 26.0435 1041.07 30.7932 1038.07 30.7932C1034.65 30.7932 1034.9 25.1748 1034.96 23C1035.09 17.7126 1038.49 14.6132 1039.23 9.88428C1039.68 6.97522 1038.03 3.10089 1038 0L673 0C680.321 15.6148 695.277 22.7283 705.087 36.0394C712.921 46.6694 714.054 59.6406 717.285 72C719.062 78.798 726.43 93.7713 720.362 98.983C707.887 109.697 688.894 105.318 676.039 99.115C651.496 87.2715 630.168 71.983 603 66.0154C583.32 61.6927 562.851 65.8156 543 63.8295C535.003 63.0294 528.443 59.3159 521 56.8025C509.445 52.9003 498.052 53 486 53C479.622 53 471.106 54.2157 465.286 51.0262C457.798 46.9227 453.164 37.5874 448.239 31.0008C440.633 20.8282 423.843 3.17859 410.83 0.277771C398.105 -2.5589 382.047 0 369 0L280 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M413 0C417.835 7.914 429.231 11.7668 435.855 18.2562C445.09 27.3037 453.367 46.179 465.286 51.4506C477.238 56.7366 493.338 51.3492 506 53.304C518.155 55.1805 528.823 62.1243 541 63.7106C559.784 66.1575 579.115 62.828 598 65.2894C611.149 67.0031 623.612 72.8123 635.961 77.2855C642.346 79.5986 646.431 84.6556 652.039 88.1782C666.413 97.2064 686.066 107.149 703 104.729C709.227 103.839 718.504 103.322 722.471 97.5177C725.992 92.3674 718.828 76.903 717.285 71C714.259 59.4244 713.186 47.2897 706.452 37.0146C700.742 28.3019 691.504 22.8961 684.303 15.5718C680.275 11.4745 677.218 2.87659 671.815 0.603394C665.762 -1.94312 655.515 0 649 0L596 0L413 0M1038 0C1038.01 3.02411 1039.29 7.01465 1038.7 9.88428C1037.73 14.6583 1030.06 26.625 1036.64 30.9136C1039.4 32.7172 1041.02 29.1457 1041.47 27.0201C1043.56 17.1583 1046.94 9.68628 1050 0L1038 0M1064 48L1058.74 67L1066.56 95L1052.46 145.289L1049.74 172.911L1043 224L1040 224L1030.29 260L1020.01 308.91L1010 330L1009 330L1008 330L1001.58 323.521L1002.55 316.925L1000 304L996 304L993 293L992 293L991.74 322L987 336C978.075 339.059 972.744 352.013 969 360L968 360C967.604 354.661 965.337 352.375 960 352C959.302 345.871 955.847 344.174 950 344C948.894 334.161 938.206 330.235 930 327.559C908.683 320.609 888.266 320 866 320C865.165 309.654 871.307 303.832 875.291 295C877.897 289.222 878.456 281.256 879.625 275C883.155 256.107 877.753 234.733 875.289 216C873.64 203.454 877.285 187.799 873.363 176C870.93 168.683 865.031 162.582 860 157C866.381 154.873 872.08 164.683 877 162C884.996 157.639 879.525 137.102 878 131C876.361 124.443 875.739 117.609 872 112C861.095 95.643 844.357 92.3392 827 88C820.711 86.4277 805.567 87.6803 800 90C797.055 91.2269 796.607 93.8149 794 95C791.118 96.3099 791.79 93.8386 792 93L788 97L785 94L785 100L784 100L784 97L783 97L776 102L776 101L782 97L782 96L772 99L773 103C747.635 99.3831 739.833 129.764 718 132C716.156 140.06 709.343 143.82 706.136 151.001C702.73 158.628 707.13 164.535 700 171L704 173C700.869 174.271 698.055 175.544 700 179L700 180L693 185L697 184L697 185L688 186C686.723 190.09 684.153 191.464 680 192L675 201C679.801 202.53 684.932 202.483 688 198L686 199L686 198L688 193L689 193L691 199C688.768 203.423 682.609 211.466 688 215L682 219L682 223L689 229L685 233L676 233L683 235C678.042 240.221 678.006 243.449 670 245L670 246C680.905 252.367 670.205 258.522 662 257L664 260L654 267L666 267L662 273L665 274L667 269L669 269L671 274L675 272C669.289 280.479 680.853 286.771 677 295L679 291L677 293L673 291L673 295L676 294L676 295C673.471 295.506 673.471 295.494 676 296L676 297L671 294L668 299L668 300L671 300L671 301L665 301L665 302C670.935 302.127 675.296 303.373 678 309C674.791 308.799 671.234 306.801 668.059 307.491C663.648 308.448 662.534 315.382 666.318 317.816C669.683 319.982 674.396 317.226 678 317C672.662 327.851 665.785 319.346 658 322L659 320L658 320C656.526 321.464 655.377 323.018 658 323L655 331L654 331L654 328L653 328L652 333L651 333L656 310L655 310L654 313C637.148 309.176 639.715 329.626 628 336C629.41 330.831 632.351 326.311 628 322L627 328L626 328L627 321L624 328L613 344L613 338L612 338L605 341L603 346L602 346L602 340C597.51 340.23 593.431 340.984 591 345L601 345L597 347L597 358L594 358L594 348L590 345L584 346L588 358L576 358L584 345C580.157 339.953 573.375 343.52 568.005 342.53C563.895 341.773 563.067 338.107 559.701 336.6C555.737 334.823 548.989 335.821 545 337L545 338L550 339L550 340L534 343L535 358L532 358L532 352L527 352L527 358L524 358L524 347L523 347L523 355L519 356L517 348L516 348L516 358L513 358L513 348L509 348L509 349L512 350L511 354L505 352L505 351C507.678 348.953 506.958 347.047 506 344C494.983 347.938 495.215 339.269 488.544 332.478C475.732 319.436 465.119 306.135 449 296.605C443.659 293.447 426.024 287.439 424 297L416 302L416 320L420 332L419 332C415.544 323.369 409.356 313.805 410.035 304C410.378 299.039 419.665 294.619 417.824 290.37C416.169 286.551 409.457 283.522 406 281.63C391.556 273.725 371.29 274.776 364.689 293.004C360.23 305.317 371.433 315.053 372.098 326.039C372.322 329.733 369.038 332.635 368 336L364 336C368.007 314.417 358.827 291.95 348.253 274C344.638 267.863 343.612 258.351 336 256L327 230C322.13 223.669 324.237 208.045 329 202C326.668 189.447 330.723 184.455 333.907 173C335.239 168.211 334.964 162.528 336.938 158C341.134 148.372 347.759 145.589 345 134L342 136L336 123C329.231 126.545 330.714 133.385 326.412 138.316C319.853 145.837 311.184 149.704 305.691 158.715C293.537 178.653 302.688 203.905 304.831 225C306.56 242.018 312.635 252.749 319.316 268C328.816 289.689 338.58 311.784 346.795 334C353.429 351.944 349.948 371.576 353.665 390C358.45 413.712 364.355 444.632 353 467L352 467L352 458L351 458L350 480L347 480L347 464L346 464C346 480.942 341.915 503.831 346 520L330 521L330 491L304 491L304 492C309.477 492 323.306 489.513 327.397 493.603C332.451 498.658 328.349 516.43 328 523L333 523L333 524L329 524L329 525L332 525L332 526L331 528L328 527L328 536L324 536C320.616 541.805 314.172 536.628 309 535.783C304.989 535.128 300.939 536.467 297 535.581C286.913 533.312 280.984 528 270 528L272 544L292 560C292.007 568.449 295.475 573.62 304 576L306 583L306 584L312 608L317 608L317 616L320 616L320 624L347 632L350 648L352 648L352 640L355 640L355.853 662.957L352 672C357.458 675.191 355.848 681.037 352 685L352 687C357.147 692.045 353.405 698.039 352 704C347.462 702.816 344.764 700.735 344 696L339 698C333.234 693.938 320.554 687.177 320 680L316 680L316 672L320 672L316 665L312 665L306.857 654.957L306 643L312 643L312 640L316 640C319.165 632.705 319.165 631.295 316 624L312 624L312 619C300.126 622.099 304 638.352 304 648L300 648L304 656L300 656C302.884 663.348 303.093 671.894 312 672L312 688L319 688C319.24 693.142 322.144 699.922 326.613 702.973C330.171 705.403 333.519 703.754 336 708L352 708L352 712L347 712L349 720L1280 720L1280 661C1280 651.35 1281.72 640.689 1277 632C1281.58 631.018 1280 624.88 1280 621L1280 588L1280 520C1280 510.122 1282.06 497.702 1279.89 488.083C1278.98 484.06 1272.78 482.36 1270.56 478.778C1264.77 469.445 1264.92 458.253 1266 448L1280 445L1280 376C1280 370.167 1282.56 355.981 1278 352C1282.21 342.057 1280 328.664 1280 318L1280 247L1280 0L1130 0L1090 0C1084.32 0 1077.15 -1.19281 1072.05 1.80402C1049.96 14.7964 1081.88 37.215 1064 48M376 37C371.837 47.8433 364.355 80.291 385 79.3241C390.521 79.0656 397.051 76.2024 402 73.8804C406.906 71.5784 429.299 65.4012 428.418 59.1111C427.991 56.0574 424.312 54.6905 421.996 53.3449C414.719 49.1167 407.817 45.2589 401 40.25C392.338 33.8856 385.787 35.5612 376 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M781 103L781 105L783 103L781 103M772.333 104.667L772.667 105.333L772.333 104.667M775 104C776.556 105.813 777.444 105.813 779 104L775 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M466 126L467 129L466 130L456 129C450.252 136.106 441.446 139.712 434.839 145.974C428.884 151.618 419.96 168.268 434 168.74C452.003 169.345 469.865 160.15 488 160L488 164C492.217 164.52 495.203 165.456 497 161L505 162L502 168L502 169L502 170L504 173L512 172L509 176L512 191C519.099 187.678 521.051 182.676 517 176L521 174C526.027 180.034 547.813 177.044 552 170L560 172L560 170C568.691 173.531 582.207 172.27 584 161L583 161L568 167C577.322 158.62 590.901 155.713 586 140L582 141L586 136C584.083 131.267 581.078 128.744 576 128C573.793 121.654 563.789 120.874 558 122C553.801 113.382 544.713 110.636 536 108.635C526.129 106.368 517.422 103.426 507.129 107.343C503.33 108.789 501.41 112.919 497.91 114.954C488.758 120.275 476.466 124.591 466 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M768 107L767 115L768 115L768 107M772.333 109.667L772.667 110.333L772.333 109.667M764 111L765 112L764 111M762 114L763 115L762 114M773 114L773 118L774 118L773 114M769 115L769 118L770 118L769 115M766 116L767 117L766 116M763 119L764 120L763 119M768 120L769 121L768 120M762 121L763 132L764 132L762 121M767 123L768 124L767 123M758.667 127.333L759.333 127.667L758.667 127.333M758 129L759 134L760 134L758 129M767.333 131.667L767.667 132.333L767.333 131.667M755 137L758 142L759 142L755 137M762 140L760 141L760 142L762 140M760 143L761 144L760 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M970 144L974 150L976 156C976.463 150.08 978.086 143.381 970 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M755 144L756 147L757 147L757 144L755 144M766 144L767 145L766 144M1145 168L1140 162C1132.98 172.604 1124.5 182.927 1120.56 195.129C1115 212.386 1114.73 231.287 1111.54 249C1107.83 269.532 1102.75 289.385 1099.7 310C1097.54 324.596 1085.44 345.391 1095.31 359.686C1099.12 365.201 1113.98 363.57 1120 364L1120 360L1126 362C1126 340.843 1116.35 320.44 1120.47 299C1121.58 293.184 1125.93 289.371 1127.59 283.961C1131.27 271.969 1132.67 258.806 1136.68 247.09C1143.46 227.292 1150.94 205.218 1151 184L1152 184L1152 192C1156.9 194.987 1156.8 200.839 1158.53 205.83C1160.07 210.294 1162.24 214.179 1162.82 219C1164.74 235.048 1158.89 265.645 1179 272L1180 289L1176 289C1177.05 292.818 1179.18 294.947 1183 296L1183 303L1184 303L1184 299L1192 304C1192.64 309.166 1194.7 318.154 1200 320C1200.11 329.597 1208.68 333.461 1213.37 341.019C1219.91 351.55 1219.83 364.491 1226.36 374.958C1228.76 378.803 1232.97 380.728 1236 384C1243.35 381.148 1247.08 378.914 1251 372C1241.65 364.874 1236.44 354.71 1232 344C1220.56 340.614 1216.93 322.807 1209.86 314.259C1200.17 302.545 1202.27 283.723 1199.68 269C1194.4 238.937 1182.12 210.662 1175.81 181C1173.04 167.959 1163.17 145.49 1148.69 160.725C1146.76 162.754 1145.87 165.411 1145 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M992 156L994 160L992 156M992 163C992.064 165.993 991.946 167.346 995 168L992 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M561 165L561 168L566 168L566 165L561 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M0 166L0 720L121 720L151 720C154.661 720 160.139 721.027 163.1 718.397C168.683 713.437 171.316 705.715 176.414 700.286C196.917 678.451 224.027 654.208 226.826 621.999C227.384 615.575 224.645 609.373 224.184 603C223.525 593.864 225.58 585.356 223.726 576C221.808 566.322 217.951 559.407 218.001 549C218.032 542.505 219.583 536.446 217.956 530C216.522 524.32 212.413 520.055 212.105 514C211.845 508.894 211.176 500.91 212.43 496.015C213.161 493.16 215.607 490.953 215.797 487.95C216.062 483.768 212.527 481.104 209 480L211 477L204 472L256 493L256 497L272 492L276 493L278 486L281 488L282 485L284 494L285 494L285 452L301 451L301 477L330 477L330 451L344 451L344 450C341.148 449.966 336.966 450.317 335.951 446.852C334.052 440.37 339.306 432.476 339.541 426C340.047 412.055 338.206 397.826 337 384L336 384L336 386L335 386C336.928 368.726 330.49 347.379 325.483 331C323.438 324.31 317.801 319.19 318 312C313.421 310.41 303.76 301.324 307 296L307 295C302.045 292.939 296.901 290.664 296 285L285 278L281 280L281 288C286.557 291.386 287.747 298.21 286 304C291.066 307.284 292.266 319.818 288 324L284 304C275.433 303.72 273.729 295.296 272 288C267.418 289.842 267.106 294.376 272 296L262 304L261 296L248.728 303.213L247.852 311.576L240 325C249.602 324.974 257.664 324.719 266 320L262 326L264 328L261 326L260 326L240 328L237 336L243 336L243 340L240 340L242 344L242 345L242 346C238.497 349.041 238.299 354.958 234.485 358.505C228.342 364.218 220.707 363.102 218 372C212.218 371.789 211.618 375.595 208 379L216.311 321.996L214.274 309L216 278L200 274L200 277C189.829 276.917 178.994 277.532 170 283L170 287L174 288C169.691 293.978 168.001 296.411 168 304L164 304L160 309L160 301L152 301C148.357 309.136 142.92 308.263 138 302C124.494 307.424 117.442 318.901 108.986 330C105.02 335.205 99.3457 343.107 100.214 350.004C100.878 355.279 104.353 358.421 106.161 363.093C109.344 371.317 111.54 383.317 110 392C116.961 397.424 120.023 408.599 125.803 415.486C129.398 419.77 134.861 421.758 138.905 425.473C146.75 432.678 153.59 440.337 162.259 446.703C167.832 450.796 182.94 456.545 184 464L194 465L194 467C171.717 466.378 145.917 445.564 129.83 431.662C122.031 424.922 112.701 418.431 105.761 410.904C101.14 405.893 98.7276 399.367 94.4545 394.209C85.7375 383.688 77.028 377.045 76.0548 362C74.5418 338.61 97.5502 319.023 111.661 303.575C130.636 282.801 151.518 263.991 170.61 243.561C178.166 235.475 181.375 224.25 189.286 216.439C196.783 209.037 206.005 205.136 213.985 198.62C218.845 194.653 222.424 189.269 227 185L226 181C191.712 181.284 157.379 181.079 123 179.375C110.659 178.763 94.047 181.921 88 168L44.0394 177.796L0 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M569 167L570 168L569 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M504 176L504 178L506 176L504 176M504 179C495.728 175.592 499.395 185.389 504 179M996 177L996 184L989 184C989.027 191.763 991.706 205.309 1000 208L1000 213L1004 212L1004 216L1005 216C1010.76 207.47 1000.11 194.148 1000 184L997 184L996 177M431 191L432 192L431 191M664 201L664 203L666 203L664 201M537 202L538 203L537 202M532 203L533 204L532 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M534 203L533 205L534 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M526 324C532.185 322.222 536.96 313.898 539 308C526.963 302.657 533.085 291.204 544 289C543.722 282.691 545.012 275.132 551 272L554 285L555 285C559.083 279.642 563.401 274.96 570 273L556 300C563.036 301.671 570.901 305.198 575.442 311.04C578.108 314.469 578.642 320.401 582.394 322.821C587.233 325.942 597.43 324 603 324C606.965 324 617.544 325.867 619.802 321.682C624.705 312.599 614.026 299.582 620.089 289.001C624.81 280.764 643.492 277.346 640.642 265.144C639.761 261.374 633.882 260.356 631.325 257.786C621.145 247.556 612 244.502 612 229C594.891 236.932 582.475 255.636 580 274C564.636 263.506 560.305 249.852 554.667 233C551.819 224.49 546.505 209.177 537.979 204.752C534.605 203 532.95 206.375 531.826 209.005C530.227 212.748 529.443 217.577 526.501 220.57C523.252 223.875 517.987 223.55 514.039 225.569C510.719 227.267 508.734 230.402 505.961 232.773C500.781 237.2 486.011 234.925 483.643 241.147C476.665 259.48 504.991 259.983 511.211 268.055C522.018 282.08 523.836 306.966 526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M537 203L538 204L537 203M538 204L539 205L538 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M540 204L541 205L540 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M539 205L540 206L539 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M532 206L533 207L532 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M540 206L541 207L540 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M690 208L693 206L690 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M532 207L533 208L532 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M541 207L543 209L541 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M542 207L543 208L542 207M685 207L686 208L685 207M530 208L531 209L530 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M531 208L532 209L531 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M543 208L545 210L543 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M531 209L532 210L531 209M542 209L544 211L542 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M543 209L544 210L543 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M529 211L530 212L529 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M530 211L531 212L530 211M544 211L545 212L544 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M545 211L546 212L545 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M530 212L531 213L530 212M545 213L546 214L545 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M529 214L530 215L529 214M546 214L547 215L546 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M529 215L530 216L529 215M546 215L547 216L546 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M528 216L529 217L528 216M547 216L548 217L547 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M548 216L549 217L548 216M1008 216L1008 221L1009 221L1008 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M528 217L529 218L528 217M548 218L549 219L548 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M549 218L550 219L549 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M527 219L528 220L527 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M527 220L528 221L527 220M549 220L550 221L549 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M550 220L551 221L550 220M522 221L523 222L522 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M526 221L527 222L526 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M521 222L521 223L524 223L521 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M524 222L525 223L524 222M550 222L551 223L550 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M518.667 223.333L519.333 223.667L518.667 223.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M520 223L521 224L520 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M513 224L514 225L513 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M515 224L516 225L515 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M516 224L517 225L516 224M551 224L552 225L551 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M552 224L553 225L552 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M513 225L514 226L513 225M511 226L512 227L511 226M552 226L553 227L552 226M510 227L511 228L510 227M553 228L554 229L553 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M509 229L510 230L509 229M553 229L554 230L553 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M612 229L612 233L613 233L612 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M508 230L509 231L508 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M608 230L609 231L608 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M506 231L507 232L506 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M507 231L508 232L507 231M554 231L555 232L554 231M607 231L608 232L607 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M554 232L555 233L554 232M606 232L607 233L606 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M686.333 232.667L686.667 233.333L686.333 232.667M688 232L688 236L684 234L687 242L692 236L690 232L688 232M691 232L692 233L691 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M1001 240L1000 240L998 238L1002 247L1006 232C1001.34 232.809 1001.1 235.69 1001 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M605 233L606 234L605 233M612 233L612 241L613 241L612 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M504 234L505 235L504 234M555 234L556 235L555 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M604 234L605 235L604 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M663 234L664 235L663 234M674 234L670 236L670 237L674 240L675 240L674 234M485 235L489 237L489 236L485 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M500.667 235.333L501.333 235.667L500.667 235.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M502 235L503 236L502 235M555 235L556 236L555 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M602 235L603 236L602 235M493 236L493 237L497 237L493 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M497.667 236.333L498.333 236.667L497.667 236.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M556.333 236.667L556.667 237.333L556.333 236.667M601 236L602 237L601 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M663 236L663 237L666 237L663 236M481 237L482 238L481 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M485 237L486 238L485 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M486 237L486 238L490 238L486 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M557 237L558 238L557 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M600 237L601 238L600 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M662 237L661 239L662 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M664.667 237.333L665.333 237.667L664.667 237.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M666 237L667 238L666 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M671 250C668.702 254.113 666.094 253.23 662 252L661 253L661 255C665.11 256.978 676.39 258.395 673.377 250.104C671.953 246.184 666.97 244.793 665 241L674 241C665.49 232.094 656.915 245.813 671 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M668.667 237.333L669.333 237.667L668.667 237.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M670 237L671 238L670 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M671 237L671 238L674 239L671 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M681 237L681 238L684 238L681 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M684 237L685 238L684 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M685 237L685 245L686 245L685 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M686.333 237.667L686.667 238.333L686.333 237.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M694 237L694 238L698 238L698 257C700.298 251.524 701.201 238.202 694 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M698 237L699 238L698 237M705 237L706 238L705 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M705 257L706 257L706 238L719 238C703.414 231.46 705 246.552 705 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M725 237C725 250.521 722.419 258 738 258L738 257L726 257L725 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M726 237L726 238L730 239L730 238L726 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M729 237L730 238L729 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M738.333 237.667L738.667 238.333L738.333 237.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M739 237L739 238L754 238L739 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M754 237L755 238L754 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M760 237L761 238L760 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M760 257L761 257L761 238L774 238C758.414 231.46 760 246.552 760 257M780 237L780 238L790 238L780 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M790 237L791 238L790 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M484 238L485 239L484 238M556 238L557 239L556 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M599 238L600 239L599 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M663 238L664 239L663 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 238L673 239L672 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M681 238L682 239L681 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M682 238L682 257L685 257L685 248C692.164 248.025 694.912 249.52 695 257L698 257L698 238L695 238C694.686 247.655 685.314 247.655 685 238L682 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M694 238L694 245L695 245L694 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M706 238L706 257L719 257L719 254L709 254C709.709 249.556 711.606 248.335 716 248L716 246C712.048 245.699 710.178 244.882 709 241C712.987 240.997 716.668 241.598 719 238L706 238M726 238L726 257L738 257L738 254L729 254L729 238L726 238M739 238L739 240C747.172 241.303 745 250.568 745 257L748 257L749 240C752.034 240.828 753.499 240.869 755 238L739 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M755 238L755 241L756 241L755 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M761 238L761 257L774 257L774 254L764 254L764 248L771 248L771 246C767.048 245.699 765.178 244.882 764 241L773 241L773 238L761 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M773.333 238.667L773.667 239.333L773.333 238.667M780 238L780 256L781 256L780 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M781 238L781 257L784 257L784 250L796 257C791.057 245.517 797.105 238.002 781 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M791 238L792 239L791 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M792 238L793 239L792 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M483 239L484 240L483 239M598 239L599 240L598 239M662 239L663 240L662 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M673 239L674 240L673 239M681 239L681 251L682 251L681 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M729 239L730 240L729 239M738 239L738 240L744 241L744 240L738 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M793 239L794 240L793 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M481 240L481 245L482 245L481 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 240L558 241L557 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M558 240L559 241L558 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M597 240L598 241L597 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M661 240L662 241L661 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M667.667 240.333L668.333 240.667L667.667 240.333M718 240L719 241L718 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M729 240L729 244L730 244L729 240M738 240L739 241L738 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M749 240L750 241L749 240M751 240L752 241L751 240M754 240L755 241L754 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M773 240L774 241L773 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M785 240L785 241L789 241L785 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M794 240L795 241L794 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M557 241L558 242L557 241M596 241L597 242L596 241M661 241L661 244L662 244L661 241M665 241L666 242L665 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M667 241L668 242L667 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M670 241L671 242L670 241M673 241L674 242L673 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M689 241L690 242L689 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M709 241L709 245L710 245L709 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M710 241L711 242L710 241M712 241L713 242L712 241M715.667 241.333L716.333 241.667L715.667 241.333M718 241L719 242L718 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 241L745 242L744 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M748 241L748 257L749 257L748 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M764 241L764 245L765 245L764 241M784 241C784.3 244.864 785.089 246.348 789 247L789 246L785 246L784 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M785 241L785 246C790.723 245.543 790.471 241.876 785 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M789 241L790 242L789 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M794 241L795 242L794 241M482 242L483 243L482 242M558.333 242.667L558.667 243.333L558.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M595 242L596 243L595 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M613 242L614 243L613 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M614 242L615 243L614 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M665.333 242.667L665.667 243.333L665.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M666 242L666 244L668 244L666 242M669 242L670 243L669 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M671.667 242.333L672.333 242.667L671.667 242.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M674 242L675 243L674 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M744 242L745 243L744 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M790 242L791 243L790 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M794 242L795 243L794 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M559 243L560 244L559 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M594 243L595 244L594 243M613 243L614 244L613 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M660 243L658 247L660 243M672.667 243.333L673.333 243.667L672.667 243.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 243L745 244L744 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M558 244L559 245L558 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M591 244L592 245L591 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M592 244L593 245L592 244M614 244L615 245L614 244M661 244L662 245L661 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M666 244L667 245L666 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M668 244L669 245L668 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688.667 244.333L689.333 244.667L688.667 244.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M729.333 244.667L729.667 245.333L729.333 244.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M744 244L744 252L745 252L744 244M790 244L791 245L790 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M794.333 244.667L794.667 245.333L794.333 244.667M483.333 245.667L483.667 246.333L483.333 245.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559.333 245.667L559.667 246.333L559.333 245.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M615 245L616 246L615 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M616 245L617 246L616 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M656 245L657 246L656 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M662 245L663 246L662 245M668 245L669 246L668 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M669 245L670 246L669 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M675 245L676 246L675 245M678 245L679 246L678 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M686 245L686 246L694 246L686 245M710 245L710 246L716 246L710 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M716 245L710 248L710 249C713.061 248.9 716.867 248.86 716 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M765 245L765 246L771 246L765 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M771.333 245.667L771.667 246.333L771.333 245.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M790 245L791 246L790 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M618 246L619 247L618 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M619 246L620 247L619 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M661 246L659 249L663 248L661 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M663 246L664 247L663 246M670 246L671 247L670 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M671 246L672 247L671 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M729 246L729 250L730 250L729 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M784 246L785 247L784 246M789 246L790 247L789 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M794 246L795 247L794 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M482 247L483 248L482 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M483 247L484 248L483 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M559 247L560 248L559 247M590 247L591 248L590 247M620 247L621 248L620 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M621 247L622 248L621 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M664 247L665 248L664 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 247L673 248L672 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M673 247L674 248L673 247M675 247L676 248L675 247M734 247L735 248L734 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M771 247L772 248L771 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M793 247L794 248L793 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M560.333 248.667L560.667 249.333L560.333 248.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M589 248L590 249L589 248M622 248L623 249L622 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M623 248L624 249L623 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M624 248L625 249L624 248M662 251L670 253C667.945 249.406 665.281 248.127 662 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M665 248L666 249L665 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M666 248L667 249L666 248M673 248L674 249L673 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M679 248L675 256L676 260C679.573 256.835 680.882 252.519 679 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M685 248L686 249L685 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M686 248L687 249L686 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M687.667 248.333L688.333 248.667L687.667 248.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689.667 248.333L690.333 248.667L689.667 248.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M691.667 248.333L692.333 248.667L691.667 248.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M693 248L694 249L693 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M716 248L717 249L716 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M764 248L765 249L764 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M765 248L765 249L771 249L765 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 248L793 249L792 248M484 249L485 250L484 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M588 249L589 250L588 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M624 249L625 250L624 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M667 249L668 250L667 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M668 249L669 250L668 249M674 249L675 250L674 249M685 249L685 257L686 257L685 249M694 249L695 250L694 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M709 249L709 254L710 254L709 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M764 249C764.872 254.225 768.345 253.984 773 254L773 253L765 253L764 249M484 250L485 251L484 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M560 250L561 251L560 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M587 250L588 251L587 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M625 250L626 251L625 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M664 250L665 251L664 250M669 250L671 252L669 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M670 250L671 251L670 250M674 250L674 253L675 253L674 250M694 250L694 256L695 256L694 250M729.333 250.667L729.667 251.333L729.333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M739 250L740 251L739 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M784 250L785 251L784 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M785.667 250.333L786.333 250.667L785.667 250.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M787 250L788 251L787 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M792 250L793 251L792 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M485 251L486 252L485 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M561 251L562 252L561 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M587 251L588 252L587 251M626 251L627 252L626 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M660 251L661 252L660 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M662.667 251.333L663.333 251.667L662.667 251.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M681 251L682 252L681 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M784 251L784 257L785 257L784 251M788 251L789 252L788 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 251L793 252L792 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M485 252L486 253L485 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M561 252L562 253L561 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M562 252L563 253L562 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M586 252L587 253L586 252M627 252L628 253L627 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M659 252L656 257L661 256L659 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M661 252L662 253L661 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M664 252L665 253L664 252M670 252L671 253L670 252M681 252L681 257L682 257L681 252M729 252L729 253L738 254L738 253L729 252M744.333 252.667L744.667 253.333L744.333 252.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 252L790 253L789 252M793 252L794 253L793 252M486 253L487 254L486 253M586 253L587 254L586 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M628 253L629 254L628 253M660 253L661 254L660 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M665 253L666 254L665 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M666 253L667 254L666 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M667.667 253.333L668.333 253.667L667.667 253.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M669 253L670 254L669 253M674 253L675 254L674 253M710 253L710 254L719 254L710 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M729 253L730 254L729 253M764 253L765 254L764 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M773 253L774 254L773 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M794 253L795 254L794 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M485 254L487 256L485 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M486 254L487 255L486 254M562 254L563 255L562 254M585 254L586 255L585 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M628 254L629 255L628 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M674 254L675 255L674 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M719 254L719 257L720 257L719 254M738 254L738 257L739 257L738 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M744 254L744 257L745 257L744 254M774 254L775 255L774 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M790 254L791 255L790 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M795 254L796 255L795 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M487 255L488 256L487 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M562 255L563 256L562 255M585 255L586 256L585 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M629 255L630 256L629 255M673 255L672 257L673 255M791 255L792 256L791 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M488 256L489 257L488 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M563 256L564 257L563 256M584 256L585 257L584 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M640 259L647 257L640 259M661 256L662 257L661 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663 256L664 257L663 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M673 256L674 257L673 256M689 256L690 257L689 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M694 256L695 257L694 256M780 256L781 257L780 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 256L793 257L792 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M796 256L797 257L796 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M489 257L490 258L489 257M563 257L564 258L563 257M584 257L585 258L584 257M630 257L631 258L630 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M639 257L640 258L639 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M664 257L665 258L664 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M665.667 257.333L666.333 257.667L665.667 257.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M667.667 257.333L668.333 257.667L667.667 257.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M669.667 257.333L670.333 257.667L669.667 257.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M671.667 257.333L672.333 257.667L671.667 257.333M672 260L676 257L672 260M681 257L681 258L686 258L681 257M694 257L694 258L699 258L694 257M706 257L706 258L710 258L706 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M710 257L711 258L710 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M711 257L712 258L711 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M712 257L713 258L712 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M713 257L714 258L713 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M714 257L714 258L717 258L714 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M717.667 257.333L718.333 257.667L717.667 257.333M746.667 257.333L747.333 257.667L746.667 257.333M761 257L761 258L774 258L761 257M781 257L782 258L781 257M783 257L784 258L783 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M490 258L491 259L490 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M564 258L565 259L564 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M631 258L632 259L631 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M633 258L633 259L639 261L639 260L633 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M680.333 258.667L680.667 259.333L680.333 258.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M491 259L492 260L491 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M564 259L565 260L564 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M583 259L584 260L583 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M632 259L633 260L632 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M633 259L634 260L633 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M639 259L640 260L639 259M642 259L643 260L642 259M661 259L662 260L661 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M492 260L493 261L492 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M493 260L494 261L493 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M565 260L566 261L565 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M583 260L584 261L583 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M634 260L635 261L634 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M635 260L636 261L635 260M678 260L674 264L674 265C676.831 264.114 678.438 263.108 678 260M703 260L704 261L703 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M494 261L495 262L494 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M495 261L496 262L495 261M636 261L637 262L636 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M637 261L638 262L637 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M641 261L642 262L641 261M197 264L200 262L197 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M496 262L497 263L496 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M497.667 262.333L498.333 262.667L497.667 262.333M566 262L567 263L566 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M582 262L583 263L582 262M640 262L641 263L640 262M499 263L499 264L504 264L499 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M504.667 263.333L505.333 263.667L504.667 263.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M567 263L568 264L567 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M582 263L583 264L582 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M642 263L643 264L642 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M664 263L666 266L664 263M692 263L693 264L692 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M507 264L508 265L507 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M508 264L509 265L508 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M568 264L569 265L568 264M641 264L641 267L642 267L641 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M667 264L667 265L670 265L667 264M671 264L672 265L671 264M684 264L685 265L684 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M509 265L510 266L509 265M569 265L570 266L569 265M581 265L582 266L581 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M642 265L640 273C642.913 270.514 643.939 268.501 642 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M510 266L511 267L510 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M570 266L571 267L570 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M581 266L582 267L581 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M681 266L682 267L681 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M571 267L572 268L571 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M641.333 267.667L641.667 268.333L641.333 267.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M650.667 267.333L651.333 267.667L650.667 267.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M671 270L674 267L671 270M686.667 267.333L687.333 267.667L686.667 267.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M511 268L512 269L511 268M572 268L573 269L572 268M580.333 268.667L580.667 269.333L580.333 268.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M512 269L513 270L512 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M573 269L574 270L573 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M640 269L641 270L640 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M666 270L666 271L670 271L666 270M682.667 269.333L683.333 269.667L682.667 269.333M719 269L721 271L719 269M736 269L735 271L736 269M751 269L752 270L751 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M512 270L513 271L512 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M574 270L575 271L574 270M580 270L581 271L580 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M640 270L641 271L640 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M667 270L659 290L676 290C674.992 283.279 671.867 274.819 667 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M668 270L669 271L668 270M682 270L682 289L683 289L682 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M683 270L683 290L686 290L686 278L699 290L699 271L696 271L696 282L683 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M684 270L685 271L684 270M695 270L696 271L695 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M696 270L696 271L699 271L696 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M699 270L700 271L699 270M706 270L707 291L708 291L706 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M707 270L707 271L711 271L707 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M718 270L719 271L718 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M719 270L719 290L722 290L722 281C727.011 284.093 728.989 284.093 734 281L734 290L737 290L737 270L736 270L727 281L719 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M737 270L737 289L738 289L737 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M751 270L743 290C750.295 288.189 752.724 287.155 760 290C758.992 283.279 755.867 274.819 751 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M752 270L753 271L752 270M767 270L767 271L770 271L770 286L771 286C771 280.738 773.023 271.999 767 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M770 270L771 271L770 270M787 270L788 271L787 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M788 270L789 271L788 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M784 286C787.498 289.964 799.517 291.672 796.377 283.101C795.391 280.409 788.982 278.166 789.631 275.267C790.106 273.147 795.437 274.16 797 274C793.961 270.559 784.668 268.329 785.466 275.972C785.789 279.065 798.242 287.106 788.039 286.034C786.444 285.866 785.623 285.848 784 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M793 270L794 271L793 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M794 270L795 271L794 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M513 271L514 272L513 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M576 271L577 272L576 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M640 271L641 272L640 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M666 271L667 272L666 271M669 271L670 272L669 271M685 271L686 272L685 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M695 271C695 275.023 696.19 280.797 693 280L693 281L696 282L695 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699 271L698 291L699 291L699 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M707 271L708 290L710 290L711 271L707 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M711 271L710 291L711 291L711 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M718 271L718 289L719 289L718 271M720 271L721 272L720 271M735 271L736 272L735 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M750 271L751 272L750 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M753 271L754 272L753 271M766 271L766 287L767 287L766 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M767 271L767 290L779 290L779 287C768.478 286.876 770 279.472 770 271L767 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M786 271L787 272L786 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M795 271L796 272L795 271M513 272L514 273L513 272M548 272L549 273L548 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M549 272L548 274L549 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M550 272L551 273L550 272M577 272L578 273L577 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M579 272L580 273L579 272M639 272L640 273L639 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M665 272L666 273L665 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M669 272L670 273L669 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M670 272L671 276L675 272L670 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M686 272L687 273L686 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M721 272L722 273L721 272M734 272L735 273L734 272M753 272L754 273L753 272M785 272L786 273L785 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M796 272L797 273L796 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M960 272L960 287L970 280C969.911 272.477 966.92 272.005 960 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M514 273L515 274L514 273M547 273L548 274L547 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M549 273L550 274L549 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M550 273L551 274L550 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M567 273L568 274L567 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M568 273L569 276L570 276L568 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M569 273L570 274L569 273M579 273L580 274L579 273M638 273L639 274L638 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M665 273L666 274L665 273M687 273L688 274L687 273M722 273L723 274L722 273M733 273L734 274L733 273M749 273L750 274L749 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M754 273L755 274L754 273M784 273L785 274L784 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 273L790 274L789 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M790.667 273.333L791.333 273.667L790.667 273.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 273L793 274L792 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M514 274L515 275L514 274M547 274L548 275L547 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M548 274L549 275L548 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M551 274L552 275L551 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M565 274L566 275L565 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M568.333 274.667L568.667 275.333L568.333 274.667M659 274L656 280L655 280L652 278C654.537 285.64 660.324 279.041 661 274L659 274M663 274L663 277L664 277L663 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M665 274L666 275L665 274M670 274L671 275L670 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M688 274L689 275L688 274M723 274L724 275L723 274M732 274L733 275L732 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M749 274L750 275L749 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M754 274L755 275L754 274M784 274L785 275L784 274M788.333 274.667L788.667 275.333L788.333 274.667M793 274L794 275L793 274M796 274L797 275L796 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M546 275L547 276L546 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M551 275L552 276L551 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M563 275L564 276L563 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M637 275L636 277L637 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M638 275L639 276L638 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M664 275L665 276L664 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M689 275L690 276L689 275M724 275L725 276L724 275M731 275L732 276L731 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M732 275L733 276L732 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M748 275L749 276L748 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M784 275L785 276L784 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M794 275L795 276L794 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M795 275L796 276L795 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M515 276L516 277L515 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M546 276L547 277L546 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M547 276L548 277L547 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M562 276L563 277L562 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M569 276L570 277L569 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M637 276L638 277L637 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M664 276L665 277L664 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M671 276L672 277L671 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M690 276L693 279L690 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M724 276L725 277L724 276M731 276L732 277L731 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M748 276L749 277L748 276M755 276L756 277L755 276M784 276L785 277L784 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M788 276L789 277L788 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M515 277L516 278L515 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M552 277L553 278L552 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M561 277L562 278L561 277M635 277L634 279L635 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M662 277L663 278L662 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M672 277L673 278L672 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M690 277L691 278L690 277M725 277L726 278L725 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M730 277L731 278L730 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M784 277L785 278L784 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 277L790 278L789 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M790 277L791 278L790 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M516.333 278.667L516.667 279.333L516.333 278.667M545 278L546 279L545 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M552 278L553 279L552 278M560 278L561 279L560 278M568 278L569 279L568 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M633 278L634 279L633 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M635.667 278.333L636.333 278.667L635.667 278.333M661 278L661 281L662 281L661 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663 278L664 279L663 278M667 278L668 279L667 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M668 278L669 279L668 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 278L673 279L672 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M686 278L687 279L686 278M691 278L692 279L691 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M726 278L727 279L726 278M729 278L730 279L729 278M747 278L748 279L747 278M751.667 278.333L752.333 278.667L751.667 278.333M756 278L757 279L756 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M785 278L786 279L785 278M791 278L792 279L791 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M792 278L793 279L792 278M545 279L546 280L545 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M553 279L553 282L554 282L553 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559 279L557 282L559 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M568 279L569 280L568 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M632 279L633 280L632 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M634 279L635 280L634 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M667.667 279.333L668.333 279.667L667.667 279.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M672 279L673 280L672 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M686 279L686 290L687 290L687 280L693 285L686 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M692 279L693 280L692 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M727.667 279.333L728.333 279.667L727.667 279.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M751 279L750 284L754 284L751 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M756 279L757 280L756 279M786 279L787 280L786 279M793 279L794 280L793 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M794 279L795 280L794 279M516 280L517 281L516 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M559 280L560 281L559 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M629 280L630 281L629 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M630 280L631 281L630 280M662 280L663 281L662 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M666 280L667 281L666 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M667 280L670 284L667 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M669 280L670 281L669 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M673 280L674 281L673 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M687 280L687 291L688 291L692 285L687 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M694 280L695 281L694 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M727 280L728 281L727 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M746 280L747 281L746 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M750 280L751 281L750 280M753 280L754 281L753 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M757 280L758 281L757 280M787 280L788 281L787 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M788 280L789 281L788 280M795 280L796 281L795 280M517.333 281.667L517.667 282.333L517.333 281.667M544 281L545 282L544 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M558 281L559 282L558 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M567 281L568 282L567 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M627 281L628 282L627 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M628 281L629 282L628 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M630 281L631 282L630 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M662 281L663 282L662 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M666 281L667 282L666 281M669 281L670 282L669 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M673 281L674 282L673 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M701.667 281.333L702.333 281.667L701.667 281.333M716 281L717 282L716 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M722 281L723 282L722 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M723 281L724 282L723 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M733 281L733 289L734 289L733 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M746 281L747 282L746 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M750 281L751 282L750 281M753 281L754 282L753 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M757 281L758 282L757 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M789 281L790 282L789 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M790 281L791 282L790 281M796 281L797 282L796 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M544.333 282.667L544.667 283.333L544.333 282.667M553.333 282.667L553.667 283.333L553.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M556 282L557 283L556 282M567 282L568 283L567 282M625 282L626 283L625 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M626 282L627 283L626 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M628 282L629 283L628 282M660 282L661 283L660 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M661 282L662 283L661 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M666 282L669 284L669 283L666 282M669 282L670 283L669 282M674 282L675 283L674 282M722 282L722 290L723 290L722 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M724 282L725 283L724 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M731 282L732 283L731 282M745 282L746 283L745 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M749.333 282.667L749.667 283.333L749.333 282.667M754.333 282.667L754.667 283.333L754.333 282.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M758 282L759 283L758 282M791 282L792 283L791 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 282L793 283L792 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M797 282L798 283L797 282M517 283L518 284L517 283M624 283L625 284L624 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M661 283L662 284L661 283M665 283L666 284L665 283M670 283L671 284L670 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M674 283L675 284L674 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M689 283L688 285L690 285L689 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M725 283L726 284L725 283M730 283L731 284L730 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M745 283L746 284L745 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M758 283L759 284L758 283M793 283L794 284L793 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M797 283L797 286L798 286L797 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M555 284L556 285L555 284M566 284L567 285L566 284M623 284L624 285L623 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M659.333 284.667L659.667 285.333L659.333 284.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M660 284L661 285L660 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M675 284L676 285L675 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M726 284L727 285L726 284M729 284L730 285L729 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M744 284L745 285L744 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M750 284L751 285L750 284M752.667 284.333L753.333 284.667L752.667 284.333M785 284L786 285L785 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M786 284L787 285L786 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M518 285L519 286L518 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M553.333 285.667L553.667 286.333L553.333 285.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M554 285L555 286L554 285M566 285L567 286L566 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M622 285L621 287L622 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M660 285L661 286L660 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M675 285L676 286L675 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M691 285L692 286L691 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M693 285L694 286L693 285M727.667 285.333L728.333 285.667L727.667 285.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 285L745 286L744 285M759 285L760 286L759 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M784 285L785 286L784 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M787 285L788 286L787 285M793 285L794 286L793 285M518.333 286.667L518.667 287.333L518.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M543.333 286.667L543.667 287.333L543.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M622 286L623 287L622 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M675 286L676 287L675 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M676 286L677 287L676 286M679 286L680 287L679 286M689 286L683 295L680 294L679 297L676 299L679 300L681 299L686 297L687 305L692 287L689 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M694 286L695 287L694 286M759 286L760 287L759 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M771 286L771 287L776 287L771 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M776 286L777 287L776 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M777 286L777 287L779 290L780 290L777 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M779 286L780 287L779 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M783 286L784 287L783 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M788 286L789 287L788 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M789 286L790 287L789 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M790 286L791 287L790 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M792 286L793 287L792 286M797 286L798 287L797 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M177 287L178 288L177 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M565 287L566 288L565 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M620 287L621 288L620 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M659 287L660 288L659 287M663 288L663 289L672 290C672.725 285.603 665.593 287.156 663 288M676 287L677 288L676 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M695 287L696 288L695 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M743 287L744 288L743 287M748 287L748 288L756 288L748 287M760 287L761 288L760 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M784 287L785 288L784 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M564 288L565 289L564 288M620 288L621 289L620 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M659 288L660 289L659 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M664.667 288.333L665.333 288.667L664.667 288.333M667 288L667 289L672 290L667 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M676.333 288.667L676.667 289.333L676.333 288.667M696 288L697 289L696 288M743 288L744 289L743 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M747 288L748 289L747 288M756 288L757 289L756 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M760.333 288.667L760.667 289.333L760.333 288.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M766 288L767 289L766 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M785 288L786 289L785 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M796 288L797 289L796 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M519 289L520 290L519 289M540 289L541 290L540 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M541.667 289.333L542.333 289.667L541.667 289.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M619 289L620 290L619 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M658 289L659 290L658 289M682 289L683 290L682 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M696 289L697 290L696 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M707 289L708 290L707 289M710 289L711 290L710 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M718 289L719 290L718 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M733 289L734 290L733 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M737 289L738 290L737 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M746 289L747 290L746 289M757 289L758 290L757 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M786 289L787 290L786 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M787 289L788 290L787 289M794 289L795 290L794 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M795 289L796 290L795 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M519.333 290.667L519.667 291.333L519.333 290.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M538 290L539 291L538 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M539 290L540 291L539 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M541 290L542 291L541 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M562 290L563 291L562 290M619 290L620 291L619 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M620 290L621 291L620 290M677 290L678 291L677 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M683 290L683 291L687 291L683 290M697 290L698 291L697 290M699 290L700 291L699 290M719 290L720 291L719 290M721 290L722 291L721 290M788 290L789 291L788 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M789 290L789 291L792 291L789 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M792 290L793 291L792 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M537 291L538 292L537 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M561 291L562 292L561 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M660 291L661 292L660 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M536 292L537 293L536 292M560 292L561 293L560 292M618 292L619 293L618 292M520 293L521 294L520 293M535 293L536 294L535 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M558 293L559 294L558 293M618.333 293.667L618.667 294.333L618.333 293.667M520 294L520 297L521 297L520 294M557 294L558 295L557 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M535 295L536 296L535 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M556 295L557 296L556 295M533 296L534 297L533 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M521.333 297.667L521.667 298.333L521.333 297.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M532 297L533 298L532 297M555.333 297.667L555.667 298.333L555.333 297.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M617 297L617 301L618 301L617 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M678 297L679 298L678 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M683 297L684 298L683 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M531 298L530 300L531 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M521.333 299.667L521.667 300.333L521.333 299.667M531 299L532 300L531 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M532 299L533 300L532 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 299L689 300L688 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M556.667 300.333L557.333 300.667L556.667 300.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M558 300L559 301L558 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M560 301L561 302L560 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M561 301L562 302L561 301M522.333 302.667L522.667 303.333L522.333 302.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M531 302L532 303L531 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M532 302L533 303L532 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M562 302L563 303L562 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M563 302L564 303L563 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M663 302L663 304L665 302L663 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M667 302L667 303L671 303L667 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M671 302L672 303L671 302M690 302L691 303L690 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M691 302L691 303L695 303L691 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M695 302L696 303L695 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M732 302L731 323L732 323L732 303L739 309L732 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M563 303L564 304L563 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M565 303L566 304L565 303M664 303L665 304L664 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M665 303L666 304L665 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M677 318L676 317C673.883 317.822 671.353 319.428 669.014 319.268C662.517 318.823 661.488 309.885 667.056 307.223C670.214 305.713 673.205 307.603 676 309C676.149 299.658 661.946 302.823 659.819 310.015C656.721 320.49 671.659 327.922 677 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M672 303L673 304L672 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M673 303L674 304L673 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M674 303L675 304L674 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M688 303L689 304L688 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M689 303L690 304L689 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M690.015 303.657C677.889 307.406 684.104 325.642 695.996 322.181C708.431 318.562 702.26 299.871 690.015 303.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M696 303L697 304L696 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M697 303L698 304L697 303M708 303L708 317L709 317L708 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M709 303C709 307.569 707.969 313.652 709.742 317.945C712.1 323.654 720.721 324.253 723.821 318.867C726.252 314.642 725 307.711 725 303C720.074 306.552 723.721 312.133 720.821 316.767C714.177 327.385 712 306.221 712 303L709 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M712 303L712 316L713 316L712 303M721 303L721 316L722 316L721 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M722.667 303.333L723.333 303.667L722.667 303.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M725 303L726 304L725 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M732 303L732 322L735 322L735 311L748 323C748 317.324 750.246 306.401 745 303L745 315L732 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 303L745 304L744 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M747 303L748 304L747 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M748 303L749 304L748 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M754 303L755 304L754 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M754 306C762.762 306.668 761.606 315.256 760 322L764 322L764 306C767.194 305.987 769.271 306.403 770 303C765.049 304.246 756.597 301.031 754 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M757 303L758 304L757 303M761 303L761 304L769 304L761 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M770 303L770 306L771 306L770 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M272 304L272 306L274 304L272 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M521 304L522 305L521 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M522.333 304.667L522.667 305.333L522.333 304.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M532 304L533 305L532 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M534 304L535 305L534 304M565 304L566 305L565 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M567 304L568 305L567 304M618.333 304.667L618.667 305.333L618.333 304.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M661 304L660 306L661 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M663 304L664 305L663 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M675 304L676 305L675 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M687 304L688 305L687 304M698 304L699 305L698 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699 304L700 305L699 304M725 304L725 316L726 316L725 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M744 304L744 313L745 313L744 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M748 304L748 323L749 323L748 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M533 305L534 306L533 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M534 305L535 306L534 305M568 305L569 306L568 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M569 305L570 306L569 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M676 305L677 306L676 305M685 305L686 306L685 305M700 305L701 306L700 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M753 305L754 306L753 305M1182 305L1184 307L1184 305L1182 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M535 306L536 307L535 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M536 306L537 307L536 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M568 306L569 307L568 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M570 306L572 308L570 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M618.333 306.667L618.667 307.333L618.333 306.667M667 306L668 307L667 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M668 306L668 307L671 307L668 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M671 306L672 307L671 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M677 306L678 307L677 306M684 306L685 307L684 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M690 306L691 307L690 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M691 306L691 307L695 307L691 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M695 306L696 307L695 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M701 306L702 307L701 306M754 306L754 307L760 307L754 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M764 306L765 307L764 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M765 306L766 307L765 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M766 306L767 307L766 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M767 306L768 307L767 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M768.667 306.333L769.333 306.667L768.667 306.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M770 306L771 307L770 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M312 307L313 308L312 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M537 307L538 308L537 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M538 307L539 308L538 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M570 307L571 308L570 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M572 307L573 308L572 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M659 307L660 308L659 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M660 307L661 308L660 307M665 307L666 308L665 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M666 307L667 308L666 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 307L673 308L672 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M673 307L675 309L673 307M677 307L676 309L677 307M684 307L685 308L684 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 307L690 308L689 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M690.228 308.032C684.044 311.681 689.47 321.614 695.852 317.968C702.204 314.339 696.565 304.294 690.228 308.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M696 307L697 308L696 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M697 307L698 308L697 307M760 307L760 321L761 321L760 307M523.333 308.667L523.667 309.333L523.333 308.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M539.333 308.667L539.667 309.333L539.333 308.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M573 308L574 309L573 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M659 308L660 309L659 308M664 308L665 309L664 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M673 308L674 309L673 308M677 308L678 309L677 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M683 308L684 309L683 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 308L689 309L688 308M697 308L698 309L697 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M702 308L703 309L702 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M574 309L575 310L574 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M619.333 309.667L619.667 310.333L619.333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M659.333 309.667L659.667 310.333L659.333 309.667M663 309L664 310L663 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M674 309L675 310L674 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M675 309L676 310L675 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M683 309L684 310L683 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 309L688 310L687 309M698 309L699 310L698 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M739 309L740 310L739 309M158 376L163 374L168 384L172 384L172 388L177 389L176.039 363.999L175.686 345.093L170 336C174.693 335.219 175.39 332.4 176 328L156 313L156 312L160 312L160 310C151.997 310.63 150.162 318.522 147.845 325C142.156 340.904 152.812 360.953 158 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M523 310L524 311L523 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M538 310L539 311L538 310M575 310L576 311L575 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663 310L664 311L663 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M682 310L683 311L682 310M687 310L688 311L687 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M699 310L700 311L699 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M703 310L703 313L704 313L703 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M740 310L741 311L740 310M538 311L539 312L538 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M539 311L540 312L539 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M575 311L576 312L575 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M619.333 311.667L619.667 312.333L619.333 311.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M620 311L621 312L620 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M663 311L663 315L664 315L663 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M682 311L682 315L683 315L682 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M686 311L686 315L687 315L686 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699 311L699 314L700 314L699 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M735.667 311.333L736.333 311.667L735.667 311.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M741 311L742 312L741 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M536 312L537 313L536 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M538 312L539 313L538 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M576 312L577 313L576 312M658.333 312.667L658.667 313.333L658.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M662.333 312.667L662.667 313.333L662.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M735 312L735 323L736 323L735 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M737 312L738 313L737 312M577 313L578 314L577 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M657 313L658 318L659 318L657 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M667 313L666 315L668 315L667 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M703 313L704 314L703 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 313L745 314L744 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M524.333 314.667L524.667 315.333L524.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M535 314L536 315L535 314M577 314L578 315L577 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M650 314L650 317L652 317L652 314L650 314M658.333 314.667L658.667 315.333L658.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M699.333 314.667L699.667 315.333L699.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M703.333 314.667L703.667 315.333L703.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M738 314L739 315L738 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M743.667 314.333L744.333 314.667L743.667 314.333M534 315L535 316L534 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M620 315L621 316L620 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M621 315L622 316L621 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M659 315L660 316L659 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663 315L664 316L663 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M682 315L683 316L682 315M687 315L688 316L687 315M739 315L740 316L739 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M523 316L524 317L523 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M524.333 316.667L524.667 317.333L524.333 316.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M578 316L579 317L578 316M620 316L620 320L621 320L620 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M659 316L660 317L659 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M674 316L675 317L674 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M675 316L676 317L675 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M683 316L684 317L683 316M687 316L688 317L687 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M698 316L699 317L698 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M712 316L713 317L712 316M721 316L722 317L721 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M725 316L726 317L725 316M740 316L741 317L740 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M533 317L534 318L533 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M534 317L535 318L534 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M578 317L579 318L578 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M664 317L665 318L664 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M673 317L674 318L673 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M676 317L678 319L676 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M677 317L678 318L677 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M683 317L684 318L683 317M688 317L689 318L688 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M697 317L698 318L697 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M702 317L703 318L702 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M713 317L714 318L713 317M720 317L719 319L720 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M741 317L742 318L741 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M659.333 318.667L659.667 319.333L659.333 318.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M660 318L661 319L660 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M665 318L666 319L665 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M666 318L667 319L666 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 318L673 319L672 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M684 318L687 321L684 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 318L690 319L689 318M696 318L697 319L696 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M709 318L710 319L709 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M714 318L715 319L714 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M720 318L721 319L720 318M724 318L725 319L724 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M742 318L743 319L742 318M532 319L533 320L532 319M579 319L580 320L579 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M661 319L662 320L661 319M667 319L668 320L667 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M668 319L669 320L668 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M669 319L669 320L672 320L669 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M677 319L678 320L677 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M684 319L685 320L684 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M691 319L692 320L691 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M692.667 319.333L693.333 319.667L692.667 319.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M694.667 319.333L695.333 319.667L694.667 319.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M701 319L702 320L701 319M709 319L710 320L709 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M715 319L716 320L715 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M716 319L716 320L719 320L716 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M724 319L725 320L724 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M743 319L744 320L743 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M525.333 320.667L525.667 321.333L525.333 320.667M662 320L663 321L662 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M676 320L677 321L676 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M685 320L686 321L685 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M700 320L701 321L700 320M710 320L711 321L710 320M723 320L724 321L723 320M744 320L745 321L744 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M764.333 320.667L764.667 321.333L764.333 320.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M531 321L532 322L531 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M580 321L581 322L580 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663 321L664 322L663 321M675 321L676 322L675 321M687 321L688 322L687 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M698 321L699 322L698 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M699 321L700 322L699 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M711 321L712 322L711 321M722 321L723 322L722 321M745 321L746 322L745 321M525 322L526 323L525 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M530 322L531 323L530 322M620 322L621 323L620 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M664 322L665 323L664 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M665 322L666 323L665 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M672 322L673 323L672 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M673 322L674 323L673 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 322L689 323L688 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 322L690 323L689 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M690 322L691 323L690 322M695 322L696 323L695 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M696 322L697 323L696 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M697 322L698 323L697 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M713 322L714 323L713 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M714 322L715 323L714 322M719 322L720 323L719 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M720 322L721 323L720 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M721 322L722 323L721 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M732 322L732 323L735 323L732 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M746 322L747 323L746 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M760 322L760 323L764 323L760 322M529 323L530 324L529 323M582 323L583 324L582 323M619 323L620 324L619 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M666.667 323.333L667.333 323.667L666.667 323.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M668.667 323.333L669.333 323.667L668.667 323.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M670.667 323.333L671.333 323.667L670.667 323.333M691 323L691 324L694 324L691 323M715 323L716 324L715 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M716 323L717 324L716 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M717.667 323.333L718.333 323.667L717.667 323.333M747 323L748 324L747 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M526 324L527 325L526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M527 324L528 325L527 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M528 324L529 325L528 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M530 324L531 325L530 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M584 324L584 325L608 325L584 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M608 324L608 325L615 325L608 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M615 324L615 325L619 325L615 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M528 325L529 326L528 325M612 325L612 326L616 326L612 325M617.667 325.333L618.333 325.667L617.667 325.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M658 325L659 326L658 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M513 344L514 345L513 344M524 344L525 345L524 344M532 344L533 345L532 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M538 344L539 345L538 344M547.667 344.333L548.333 344.667L547.667 344.333M561 344L561 357L562 357L562 345L565 347L561 344M570 344L570 345L572 356L573 356C573 351.614 574.033 346.615 570 344M574 344L576 346L574 344M577 344L578 345L577 344M592 344L593 345L592 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M507 345L508 348L509 348L509 345L507 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M509.333 345.667L509.667 346.333L509.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M510 345L510 346L520 347L510 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M522 345L523 346L522 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M524 345L524 358L527 352L526 352L526 357L525 357L524 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M525 345L526 346L525 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M526 345L526 350L527 350L526 345M532 345L532 350L533 350L532 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M533 345L534 357L535 357L533 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M534 345L535 346L534 345M540 345L541 346L540 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M540 357L541 357L541 346L548 346C539.559 342.496 540 351.149 540 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M548.333 345.667L548.667 346.333L548.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M562 345L563 346L562 345M570.667 345.333L571.333 345.667L570.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M581 345L582 346L581 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M582 345L581 347L582 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M590 345L591 346L590 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M590 346L590 347L600 346L590 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M600.333 345.667L600.667 346.333L600.333 345.667M605 345L606 346L605 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M606 345L605 355L606 355L606 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M607 345L608 346L607 345M615 345L616 346L615 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M616 345L617 346L616 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M617 345L617 346L621 346L621 345L617 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M618.667 345.333L619.333 345.667L618.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M621 345L622 346L621 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M622 345L623 346L622 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M630.667 345.333L631.333 345.667L630.667 345.333M638 345L638 349L639 349L638 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M639 345L640 346L639 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M640 345L641 346L640 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M650 345L651 346L650 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M651 345L652 346L651 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M661 345L662 346L661 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M662 345L663 351L664 351L662 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663 345L664 346L663 345M681 345L682 346L681 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M681 357L682 357L682 346L687 346C679.891 343.299 681 352.488 681 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 345L688 346L687 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 345L689 346L688 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M700.667 345.333L701.333 345.667L700.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M709 347L719 346C715.756 344.639 711.437 344.211 709 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M719 345L720 346L719 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M726 345L727 346L726 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M727 345L726 347L727 345M738 345L738 346L744 346L738 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M744 345L746 347L744 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M756 345L758 347L756 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M757 345L758 346L757 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M768 345L769 346L768 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M769 345L769 346L773 346L773 345L769 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M770.667 345.333L771.333 345.667L770.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M773 345L774 348L775 348L773 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M780 345L781 346L780 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M780 357L781 357L781 346L788 346C779.559 342.496 780 351.149 780 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M788 345L789 346L788 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M510 346L510 347L514 347L514 357L515 357L515 347L519 347L510 346M525 346L525 357L526 357L525 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M527 346L527 350L532 350L532 346L531 346L531 349L530 349L527 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M533 346L533 357L534 357L533 346M541 346L541 357L548 357L548 356L542 356L542 347L548 347L541 346M562 346L562 357L563 357L564 349L565 349L572 357L570 346L571 353L562 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M569 346L570 347L569 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M582 346L577 357L587 357L582 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M583 346L584 347L583 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M591 346L591 347L595 347L595 357L596 357L596 347L600 347L591 346M606 346L606 357L607 357L606 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M607.333 346.667L607.667 347.333L607.333 346.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M612 346L613 347L612 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M614 346L615 347L614 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M620 346L620 347C631.17 356.576 606.83 356.576 618 347C611.837 345.66 612.272 355.492 618.015 356.638C625.786 358.189 626.366 348.436 620 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M622 346L623 347L622 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M623 346L624 347L623 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M630 346L630 357L631 357L630 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M631 346L631 357L632 357L632 349L640 357L640 346L639 346L639 353L631 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M632 346L633 347L632 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M640 346L639 358L640 358L640 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M649 346L650 347L649 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M650 346L646 357L656 357L650 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M661 346L661 353L662 353L661 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M662 346L662 357L669 357L669 356L663 356L662 346M682 346L682 357C693.053 356.733 693.105 346.131 682 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 346L690 347L689 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M700 346L696 357L706 357L700 346M710 346L710 347L714 347L714 357L715 357L715 347L719 347L710 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M719 346L720 347L719 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M727 346L722 357L732 357L727 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M728 346L729 347L728 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M738 346L738 357C747.358 356.967 745.488 353.758 745 346L738 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M755 346L756 347L755 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M756 346L752 357L762 357L756 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M767 346L768 347L767 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M768 346L773 356L767 355L767 356C775.079 358.151 773.727 351.954 768 349L768 348L770 346L768 346M772 346L774 348L774 346L772 346M781 346L781 357L788 357L788 356L782 356L782 347L788 347L781 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M788 346L789 347L788 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M428 347L430 350L430 347L428 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M513 347C513 349.136 514.464 362.155 516 355L515 355L515 357L514 357L513 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M515 347L516 348L515 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M542 347L542 350L543 350L542 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M543 347L543 348L549 348L543 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M564 347L565 348L564 347M570 347L570 353L571 353L570 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M580 347L581 348L580 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M583 347L584 348L583 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M590 347L590 348L594 348L590 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M594 347L595 348L594 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M596 347L596 357L595 357L595 348L594 348L595 358L596 358L596 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M598.667 347.333L599.333 347.667L598.667 347.333M613 347L612 349L613 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M616 347L615 349L616 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M617 347L618 348L617 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M618.129 347.971C613.678 349.081 615.358 356.155 619.871 355.029C624.322 353.919 622.642 346.845 618.129 347.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M620 347L621 348L620 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M621 347L622 348L621 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M624 347L625 348L624 347M633 347L634 348L633 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M649 347L650 348L649 347M652 347L653 348L652 347M683 347L684 348L683 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M684 347L684 355C690.313 353.946 689.012 349.127 684 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M685.667 347.333L686.333 347.667L685.667 347.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 347L688 348L687 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M690 347L691 348L690 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699 347L700 348L699 347M702 347L703 348L702 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M713 347L713 357L714 357L713 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M715 347L716 348L715 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M725 347L726 348L725 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M728 347L729 348L728 347M739 347L739 356L740 356L743 352L739 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M740 347L740 350L744 349L740 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M743 347L744 348L743 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M745 347L745 350L746 350L745 347M755 347L756 348L755 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M758 347L759 348L758 347M766.333 347.667L766.667 348.333L766.333 347.667M769 347L770 348L769 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M772 347L773 348L772 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M782 347L783 348L782 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M515 348L515 352L516 352L515 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M565 348L566 349L565 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M580 348L581 349L580 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M584 348L585 349L584 348M607 348L607 357L608 357L607 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M613 348L614 349L613 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M622 348L623 349L622 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M624 348L625 349L624 348M649 348L650 349L649 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M683 348L684 349L683 348M688 348L689 349L688 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M691 348L692 349L691 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M699 348L700 349L699 348M702 348L703 349L702 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M715 348L715 357L716 357L715 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M725 348L726 349L725 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M729 348L730 349L729 348M754 348L755 349L754 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M758 348L759 349L758 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M768 348L769 349L768 348M564 349L563 357L564 357C564 353.292 563.107 350.277 566 351L564 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M566 349L567 350L566 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M579 349L580 350L579 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M582 349L581 351L582 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M584 349L585 350L584 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M612 349L612 353L613 353L612 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M614 349L615 350L614 349M623.333 349.667L623.667 350.333L623.333 349.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M625 349L626 350L625 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M632 349L633 350L632 349M634 349L635 350L634 349M638 349L639 350L638 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M648 349L649 350L648 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M650 349L651 350L650 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M651 349L652 350L651 349M653 349L654 350L653 349M683 349L683 353L684 353L683 349M689 349L690 350L689 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M691 349L691 353L692 353L691 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M698 349L699 350L698 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M700 349L701 350L700 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M701 349L702 350L701 349M703 349L704 350L703 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M726 349L727 350L726 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M727 349L726 351L727 349M729 349L730 350L729 349M743 349L744 350L743 349M754 349L755 350L754 349M756 349L758 351L756 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M757 349L758 350L757 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M769 349L770 350L769 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M1279 349L1278 352L1279 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M508 350L509 351L508 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M527 352L533 351L527 352M542 350L542 352L547 352L547 350L542 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M547 350L548 351L547 350M564 350L565 351L564 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M567 350L568 351L567 350M579 350L580 351L579 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M582 350L581 353L582 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M585 350L586 351L585 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M614 350L614 353L615 353L614 350M625 350L625 353L626 353L625 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M632 350L632 357L633 357L632 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M633 350L634 351L633 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M635 350L636 351L635 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M638 350L637 353L638 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M648 350L649 351L648 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M650.667 350.333L651.333 350.667L650.667 350.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M653 350L654 351L653 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M689 350L689 353L690 353L689 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M698 350L699 351L698 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M700.667 350.333L701.333 350.667L700.667 350.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M703 350L704 351L703 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M724 350L725 351L724 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M727 350L726 353L727 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M737 350L737 357L738 357L737 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M745 350L746 351L745 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M756 350L758 353L756 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M759 350L760 351L759 350M767 350L768 351L767 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M770 350L771 351L770 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M771 350L772 351L771 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M782 350L782 352L786 352L786 350L782 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M786.333 350.667L786.667 351.333L786.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M103 351L104 352L103 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M530 351L531 352L530 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M565 351L566 352L565 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M568 351L569 352L568 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M579 351L580 352L579 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M581 351L582 352L581 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M583 351L584 352L583 351M585 351L586 352L585 351M623 351L624 352L623 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M634 351L635 352L634 351M636 351L637 352L636 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M647 351L648 352L647 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M649 351L650 352L649 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M650 351L650 353L652 353L652 351L650 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M652 351L653 352L652 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M654 351L655 352L654 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M663.333 351.667L663.667 352.333L663.333 351.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M685 351L686 352L685 351M697 351L698 352L697 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M699 351L700 352L699 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M700 351L700 353L702 353L702 351L700 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M702 351L703 352L702 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M704 351L705 352L704 351M726 351L727 352L726 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M728 351L729 352L728 351M730 351L731 352L730 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M741 351L742 352L741 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M745 351L747 353L745 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M746 351L747 352L746 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M753 351L754 352L753 351M755 351L756 352L755 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M757 351L758 352L757 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M759 351L760 352L759 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M768 351L769 352L768 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M769 351L770 352L769 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M773 351L774 352L773 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M515 352L516 353L515 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M528 352L529 353L528 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M532 352L535 358L535 357L532 352M542.333 352.667L542.667 353.333L542.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M566 352L567 353L566 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M569 352L570 353L569 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M578 352L579 353L578 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M580 352L581 353L580 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M583 352L581 353L581 354L583 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M585 352L586 353L585 352M623 352L624 353L623 352M635 352L636 353L635 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M647 352L648 353L647 352M649.333 352.667L649.667 353.333L649.333 352.667M652 352L653 353L652 352M654 352L655 353L654 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M697 352L698 353L697 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699.333 352.667L699.667 353.333L699.333 352.667M702.333 352.667L702.667 353.333L702.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M704 352L705 353L704 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M723 352L724 353L723 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M725 352L726 353L725 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M728 352L726 353L726 354L728 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M730 352L731 353L730 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M740 352L740 355L745 355L740 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 352L745 353L744 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M753 352L754 353L753 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M755 352L758 354L758 353L755 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M758 352L759 353L758 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M760 352L761 353L760 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M770 352L771 353L770 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M771 352L772 353L771 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M774 352L775 353L774 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M515 353L516 354L515 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M520 353L521 354L520 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M567 353L568 354L567 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M578 353L579 354L578 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M580 353L581 354L580 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M584 353L585 354L584 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M586 353L587 354L586 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M612 353L613 354L612 353M650 353L650 354L653 354L650 353M655 353L656 354L655 353M661 353L662 354L661 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M663 353L664 354L663 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M683 353L686 356L686 355L683 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M689 353L690 354L689 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M691 353L692 354L691 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M700.667 353.333L701.333 353.667L700.667 353.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M723 353L724 354L723 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M725 353L726 354L725 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M729 353L730 354L729 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M731 353L732 354L731 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M745 353L746 354L745 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M747.333 353.667L747.667 354.333L747.333 353.667M752 353L753 354L752 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M758 353L759 354L758 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M760 353L761 354L760 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M772 353L773 354L772 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M774.333 353.667L774.667 354.333L774.333 353.667M515 354L516 355L515 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M542 354L542 355L549 356L549 355L542 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M568 354L569 355L568 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M577 354L578 355L577 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M586 354L587 355L586 354M613 354L614 355L613 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M615 354L616 355L615 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M622 354L623 355L622 354M624 354L625 355L624 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M636 354L637 355L636 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M646 354L647 355L646 354M655 354L656 355L655 354M661 354C662.223 357.687 664.308 357.88 668 358L668 357L661 354M663 354L664 355L663 354M688 354L689 355L688 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M691 354L692 355L691 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M696 354L697 355L696 354M705 354L706 355L705 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M722 354L723 355L722 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M731 354L732 355L731 354M752 354L753 355L752 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M761 354L762 355L761 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M766 354L767 355L766 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M767 354L768 355L767 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M772 354L771 356L772 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M542 355L543 356L542 355M569 355L570 356L569 355M577 355L578 356L577 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M579 355L580 356L579 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M580 355L580 356L585 356L580 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M587 355L588 356L587 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M605 355L606 356L605 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M614 355L615 356L614 355M616 355L617 356L616 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M617 355L618 356L617 355M620 355L621 356L620 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M621 355L622 356L621 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M637 355L638 356L637 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M646 355L647 356L646 355M648 355L649 356L648 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M649 355L649 356L654 356L649 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M663 355L664 356L663 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M664 355L664 356L670 356L664 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M683 355L684 356L683 355M686 355L687 356L686 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M687 355L688 356L687 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M690 355L691 356L690 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M696 355L697 356L696 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M698 355L698 356L704 356L698 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M705 355L706 356L705 355M722 355L723 356L722 355M724 355L725 356L724 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M725 355L725 356L730 356L725 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M732 355L733 356L732 355M740 355L740 356L744 356L740 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M744 355L745 356L744 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M746 355L747 356L746 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M751 355L752 356L751 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M754 355L754 356L759 356L754 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M759 355L760 356L759 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M761 355L762 356L761 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M766 355L767 356L766 355M768 355L769 356L768 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M769 355L770 356L769 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M772 355L773 356L772 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M774 355L775 356L774 355M782 355L783 356L782 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M784.667 355.333L785.333 355.667L784.667 355.333M529 356L530 357L529 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M548 356L549 357L548 356M570 356L571 357L570 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M576.333 356.667L576.667 357.333L576.333 356.667M579 356L580 357L579 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M585 356L586 357L585 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M587 356L588 357L587 356M605 356L606 357L605 356M615 356L616 357L615 356M622 356L623 357L622 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M638 356L639 357L638 356M645 356L645 358L647 358L645 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M647 356L648 357L647 356M654 356L655 357L654 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M656 356L655 358L657 358L656 356M669 356L670 357L669 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M660 373C654.792 377.294 660.326 386.616 666.775 381.656C671.274 378.196 673.271 361.794 676 356C667.752 357.165 658.437 363.858 660 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M688 356L689 357L688 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 356L690 357L689 356M695 356L695 358L697 358L695 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M697 356L698 357L697 356M704 356L705 357L704 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M706 356L705 358L707 358L706 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M721.333 356.667L721.667 357.333L721.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M730 356L733 358L733 357L730 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M732 356L733 357L732 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M746 356L747 357L746 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M751 356L751 358L753 358L751 356M753 356L754 357L753 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M762.333 356.667L762.667 357.333L762.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M767 356L768 357L767 356M773 356L774 357L773 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M788 356L780 357L780 358L789 357L788 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M513 357L514 358L513 357M520 357L521 358L520 357M526 357L527 358L526 357M532 357L533 358L532 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M540 357L540 358L549 358L540 357M562.667 357.333L563.333 357.667L562.667 357.333M571 357L572 358L571 357M577.667 357.333L578.333 357.667L577.667 357.333M586.667 357.333L587.333 357.667L586.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M594 357L595 358L594 357M596 357L597 358L596 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M605.667 357.333L606.333 357.667L605.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M616 357L617 358L616 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M617 357L618 358L617 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M618.667 357.333L619.333 357.667L618.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M620 357L621 358L620 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M621 357L622 358L621 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M630.667 357.333L631.333 357.667L630.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M640 357L641 358L640 357M647 357L648 358L647 357M654 357L655 358L654 357M661 357L662 358L661 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M668 357L669 358L668 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M669 357L670 358L669 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M681 357L681 358L687 358L681 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M687 357L688 358L687 357M697 357L698 358L697 357M704 357L705 358L704 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M713.667 357.333L714.333 357.667L713.667 357.333M722.667 357.333L723.333 357.667L722.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M730 357L731 358L730 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M738 357L738 358L745 358L738 357M760 357L761 358L760 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M761 357L762 358L761 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M768 357L769 358L768 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M769 357L769 358L772 358L769 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M772 357L773 358L772 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M788 357L789 358L788 357M1130 364L1133 368L1133 364L1130 364M1136 367L1137 368L1136 367M1138 368L1144 375L1144 384L1148 384C1148.88 388.21 1150.84 390.748 1155 392L1144 368L1138 368M1157 392L1160 395L1157 392M1153 394L1154 395L1153 394M1160 398L1160 400L1162 400L1160 398M1165 408L1168 411L1165 408M472 418L473 419L472 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M358 433L358 440L359 440L358 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M1239 440C1241.61 450.402 1239.32 454.089 1238 464L1224 461C1222.85 471.744 1227.68 478.914 1232 488L1240 486L1240 480L1257 489C1255.11 481.048 1257.72 472.779 1247 472L1250 464L1247 448C1243.21 446.265 1242.03 444.139 1242 440L1239 440M1266 448C1263.33 460.928 1265.2 481.263 1280 486L1280 445L1266 448M327 448L327 451L330 450L330 449L327 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M346 448L347 449L346 448M1278 448L1278 452L1280 452L1280 448L1278 448M344 449L346 451L344 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M700 450L701 451L700 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M701 450L701 451L704 451L701 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M704 450L704 451L714 451L704 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M714.667 450.333L715.333 450.667L714.667 450.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M716 450L717 451L716 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M286 451L287 452L286 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M286 452L286 453L298 452L286 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M298 451L299 452L298 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M299 451L300 452L299 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M300 451L301 452L300 451M330 451L331 452L330 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M331 451L331 452L344 452L331 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M344 451L345 452L344 451M697 451L698 452L697 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M698.667 451.333L699.333 451.667L698.667 451.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M739 504L728 498C715.496 515.592 686.347 509.402 686.347 486C686.347 462.465 715.483 456.38 728 474L739 468C731.091 447.864 701.415 446.406 686.015 457.927C674.784 466.329 671.563 479.637 673.184 493C676.792 522.733 727.473 533.752 739 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M718 451L719 452L718 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M719 451L720 452L719 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M720 451L721 452L720 451M285 452L286 453L285 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M286 453L286 520L300 520L300 490L331 490L331 520L345 520C341.173 499.383 342.313 472.754 345 452L331 452L331 478L300 478L300 452L286 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M300 452L300 478L301 478L300 452M330 452L330 478L331 478L330 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M346 452L346 456L347 456L346 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M694 452L695 453L694 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M695 452L696 453L695 452M721 452L722 453L721 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M722 452L723 453L722 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M328 453L326 461L327 461L328 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M344 453L345 454L344 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M692 453L693 454L692 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M693 453L694 454L693 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M724 453L725 454L724 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M286.333 454.667L286.667 455.333L286.333 454.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M690 454L691 455L690 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M691 454L692 455L691 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M726 454L727 455L726 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M344 455L345 456L344 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M542 455L543 456L542 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M539 468L539 469C544.465 467.186 543 460.845 543 456L557 456C553.739 454.632 544.553 453.356 542.603 457.318C540.628 461.332 543.325 465.196 539 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M689 455L690 456L689 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M728 455L729 456L728 455M909 468C899.994 468.107 901 473.43 901 481L902 481L902 469L910 469L910 456L924 456C912.251 451.07 909 457.8 909 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M543 456L543 469L535 469L535 480L543 480C543 490.222 540.019 506.254 546.652 514.895C550.419 519.803 567.098 525.283 571.972 519.258C573.911 516.862 573 511.881 573 509C568.886 509 563.683 509.782 560.133 507.258C555.211 503.757 553.137 486.07 557.603 481.603C560.483 478.724 567.279 480 571 480L571 469L556 469L556 456L543 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M556 456L556 469L557 469L556 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 456L688 457L687 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M729 456L730 457L729 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M910 456L910 469L902 469L902 480L910 480C910 490.263 906.958 506.267 913.649 514.895C917.438 519.781 934.084 525.299 938.972 519.258C940.911 516.862 940 511.881 940 509C935.971 509 930.587 509.905 927.133 507.397C922.239 503.841 920.12 486.087 924.603 481.603C927.483 478.724 934.279 480 938 480L938 469C926.383 469 923 468.267 923 456L910 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M923 456L923 468L924 468L923 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M686 457L687 458L686 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M731 457L732 458L731 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M685 458L686 459L685 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M732 458L733 459L732 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M683 459L684 460L683 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M733 459L734 460L733 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M320 460L320 475L322 475C322 470.477 323.864 462.92 320 460M682 460L683 461L682 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M734 460L736 462L734 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M344 461L344 518L345 518L345 479L344 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M681 461L682 462L681 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M734 461L735 462L734 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M680 462L681 463L680 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M736 462L737 463L736 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M680 463L681 464L680 463M704 463L705 464L704 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M705 463L705 464L708 464L705 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M708 463L709 464L708 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M709 463L709 464L713 464L709 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M713 463L714 464L713 463M679 464L680 465L679 464M700 464L701 465L700 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M701 464L702 465L701 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M702 464L703 465L702 464M715 464L716 465L715 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M716 464L717 465L716 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M717 464L718 465L717 464M737 464L738 465L737 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M678 465L679 466L678 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M698 465L699 466L698 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699 465L700 466L699 465M718 465L719 466L718 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M719 465L720 466L719 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M738 465L739 466L738 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M326 466L328 469L326 466M677 466L678 467L677 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M696 466L697 467L696 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M697 466L698 467L697 466M720 466L721 467L720 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M739 466L740 467L739 466M378.667 467.333L379.333 467.667L378.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M380 467L380 468L388 468L380 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M388.667 467.333L389.333 467.667L388.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M456 467L456 468L462 469L456 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M602 467L603 468L602 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M603 467L603 468L611 468L603 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M611 467L612 468L611 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M677 467L678 468L677 467M695 467L696 468L695 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M721 467L722 468L721 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M722 467L723 468L722 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M739 467L740 468L739 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M809 467L810 468L809 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M810 467L810 468L818 468L810 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M818 467L819 468L818 467M866 467L867 468L866 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M867 467L867 468L875 468L867 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M875 467L876 468L875 467M968.667 467.333L969.333 467.667L968.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M970 467L970 468L977 468L970 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M977 467L978 468L977 467M374 468L375 469L374 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M375 468L376 469L375 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M376.667 468.333L377.333 468.667L376.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M378 468.468C343.002 475.07 355.564 526.427 390 520.674C425.344 514.77 412.73 461.915 378 468.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M391 468L392 469L391 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M392 468L393 469L392 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M393 468L394 469L393 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M415.667 468.333L416.333 468.667L415.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M417 468L418 469L417 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M418 468L418 469L421 469L418 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M421 468L422 469L421 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M422 468L422 469L431 470L422 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M455 468L456 469L455 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M441 498C440.067 491.777 434.525 472.501 428.582 469.603C425.223 467.966 419.664 469 416 469C419.949 482.814 427.838 495.847 433.576 509C434.951 512.153 437.213 521.102 441.842 520.534C444.757 520.176 446.257 516.246 447.399 513.999C451.073 506.772 454.884 499.484 458 492L460 492C461.906 500.024 466.486 507.684 470.248 514.995C471.514 517.456 473.306 521.595 476.83 520.338C480.969 518.862 482.563 511.56 484.255 508C490.365 495.151 496.533 482.13 502 469L487 469C484.567 477.509 480.589 490.981 474 497C472.516 488.674 467.096 480.589 463.409 473.019C462.186 470.508 459.901 466.912 456.634 469.047C448.412 474.422 448.258 490.941 441 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M487 468L488 469L487 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M488 468L488 469L502 469L488 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M534 468L535 469L534 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M535 468L536 469L535 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M536 468L536 469L539 469L536 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M542 468L543 469L542 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 468L558 469L557 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M558 468L559 469L558 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559 468L559 469L569 469L559 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M569 468L570 469L569 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M570 468L571 480L572 480L570 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M571 468L572 469L571 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M598.667 468.333L599.333 468.667L598.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M600 468.529C564.841 476.6 580.543 528.282 615 520.319C649.428 512.363 633.756 460.781 600 468.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M614 468L615 469L614 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M615 468L616 469L615 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M616 468L617 469L616 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M676 468L677 469L676 468M694 468L695 469L694 468M723 468L724 469L723 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M737 468L738 469L737 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M738 468L739 469L738 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M750 520L751 520L751 469L764 470C760.866 467.625 751.844 466.009 750.318 471.148C746.206 485 750 505.512 750 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M763 468L764 469L763 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M772.667 468.333L773.333 468.667L772.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M774.667 468.333L775.333 468.667L774.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M763 475L763 469L751 469L751 520L764 520C764 503.885 759.677 481.187 782 481C782 477.93 783.058 472.274 780.972 469.746C776.664 464.523 766.342 472.161 763 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M780 468L781 469L780 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M781 468L782 481L783 481L781 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M782 468L783 469L782 468M805 468L806 469L805 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M806 468L807 469L806 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M807 468L808 469L807 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M836 514L836 513L831 505C819.083 509.955 807.836 513.246 801 499L838 499C838 491.118 838.818 483.573 833.61 477.004C821.949 462.297 797.619 466.313 789.916 483C776.168 512.783 813.91 530.795 836 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M820 468L821 469L820 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M821.667 468.333L822.333 468.667L821.667 468.333M862.667 468.333L863.333 468.667L862.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M864 468L865 469L864 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M880 491C870.976 492.455 858.263 489.417 851.133 496.225C843.793 503.233 846.713 516.197 856.001 519.852C864.594 523.234 873.399 519.983 881 516L881 520L893 520C893 506.419 897.679 482.3 885.906 472.533C878.53 466.414 866.247 466.707 858 470.832C855.132 472.266 849.501 475.081 850.256 479.039C852.38 490.166 862.369 480.515 868 479.855C875.347 478.994 878.37 484.975 880 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M877 468L878 469L877 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M878.667 468.333L879.333 468.667L878.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M901 468L902 469L901 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M924 468L924 469L938 469L924 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M964 468L965 469L964 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M965 468L966 469L965 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M966 468L967 469L966 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M990 505C977.163 509.664 969.527 512.468 960 500L997 499C997.267 492.348 997.728 486.182 994.622 480.001C980.073 451.05 935.761 477.502 948.916 506C954.237 517.528 965.141 521.28 977 520.985C988.34 520.704 996.805 516.145 990 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M980 468L981 469L980 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M981 468L982 469L981 468M372 469L373 470L372 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M373 469L374 470L373 469M394 469L395 470L394 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M395 469L396 470L395 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M415 469L416 470L415 469M455 469L456 470L455 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M486 469L487 470L486 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M534 469L534 481L535 481L534 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M595 469L596 470L595 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M596 469L597 470L596 469M617 469L618 470L617 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M618 469L619 470L618 469M693 469L694 470L693 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M724 469L725 470L724 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M736 469L737 470L736 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M769 469L770 470L769 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M770 469L771 470L770 469M803 469L804 470L803 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M804 469L805 470L804 469M824 469L825 470L824 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M825 469L826 470L825 469M859 469L860 470L859 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M860 469L861 470L860 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M881 469L882 470L881 469M938 469L938 480L924 480L924 481C932.743 481 943.056 481.05 938 469M962 469L963 470L962 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M963 469L964 470L963 469M983 469L984 470L983 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M984 469L985 470L984 469M200 470L201 471L200 470M370 470L371 471L370 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M371 470L372 471L371 470M396 470L397 471L396 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M397 470L398 471L397 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M415 470L416 471L415 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M430 470L431 471L430 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M454 470L455 471L454 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M462 470L463 471L462 470M486 470L487 471L486 470M501 470L502 471L501 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M593 470L594 471L593 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M594 470L595 471L594 470M619 470L620 471L619 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M620 470L621 471L620 470M675 470L676 471L675 470M692 470L693 471L692 470M725 470L726 471L725 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M735 470L736 471L735 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M763 470L764 471L763 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M768 470L769 471L768 470M801 470L802 471L801 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M826 470L827 471L826 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M827 470L828 471L827 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M857 470L858 471L857 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M858 470L859 471L858 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M883 470L884 471L883 470M960 470L961 471L960 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M985 470L986 471L985 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M986 470L987 471L986 470M368 471L369 472L368 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M369 471L370 472L369 471M398 471L399 472L398 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M399 471L400 472L399 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M416 471L417 472L416 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M431 471L432 472L431 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M454 471L455 472L454 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M486 471L487 472L486 471M592 471L593 472L592 471M621 471L622 472L621 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M622 471L623 472L622 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M691 471L692 472L691 471M726 471L727 472L726 471M733 471L734 472L733 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M763 471L763 474L764 474L763 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M766 471L767 472L766 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M767 471L768 472L767 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M799 471L800 472L799 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M828 471L829 472L828 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M855 471L856 472L855 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M856 471L857 472L856 471M884 471L885 472L884 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M885 471L886 472L885 471M958 471L959 472L958 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M959 471L960 472L959 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M987 471L988 472L987 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M204 472L211 477L209 480C218.337 484.783 213.568 488.489 212.228 496.015C211.09 502.402 210.931 513.846 213.017 520C214.807 525.283 218.078 529.229 218.696 535C219.611 543.546 217.167 552.297 218.428 561C219.272 566.823 222.619 571.414 223.726 577C225.435 585.625 223.889 593.466 224.054 602C224.172 608.097 226.8 613.957 226.82 620C226.854 630.369 221.345 641.171 216.431 650C210.305 661.003 203.534 672.862 194.764 681.996C183.595 693.628 168.157 703.889 163 720L264 720L266 716L266 715L264 712L272 708L272 712C279.707 712 284.539 712.262 288 720L325 720L320 716C321.251 711.306 323.55 708.905 328 707L328 712L332 712L332 720L349 720L347 712L352 712L352 708L336 708C334.374 703.376 330.92 705.211 327.38 702.973C322.921 700.156 319.457 693.025 319 688L312 688L312 672C302.872 671.703 303.853 662.758 300 656L304 656L300 648L304 648C304 637.609 300.587 623.849 312 619L312 624L316 624C317.974 631.364 317.974 632.636 316 640L312 640L312 643L306 643L306.857 655.896L312 665L316 665L320 672L316 672L316 680L320 680C320.241 687.262 332.653 695.04 339 698L344 696C344.405 701.143 346.974 703.264 352 704C353.847 698.874 357.695 690.692 352 687L352 685C356.348 681.952 357.91 674.078 352 672L355 640L352 640L352 648L350 648L347 632C336.785 626.824 331.937 624 320 624L320 616L317 616L317 608L312 608L306 584L306 583L304 576C296.377 572.57 292.03 568.519 292 560L272 544L270 528C280.551 528 286.308 533.305 296 535.585C300.6 536.667 305.354 535.167 310 536.188C314.709 537.224 321.784 542.61 324 536L328 536L328 527L331 528L332 526L332 525L329 525L329 524L333 524L333 523L328 523C328.936 517.559 332.149 496.792 327.397 493.028C322.472 489.127 309.275 492.494 303 491C300.986 497.813 305.246 515.594 298.682 519.972C295.514 522.085 289.642 521 286 521L286 485L285 485L285 494L284 494L282 485L281 488L278 486L276 493L272 492L256 497L256 493L204 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M367 472L368 473L367 472M400 472L401 473L400 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M416 472L417 473L416 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M431 472L432 473L431 472M463 472L464 473L463 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M485 472L486 473L485 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M500 472L501 473L500 472M590 472L591 473L590 472M623 472L624 473L623 472M674 472L675 473L674 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M690 472L691 473L690 472M727 472L728 473L727 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M732 472L733 473L732 472M765 472L766 473L765 472M798 472L799 473L798 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M829 472L830 473L829 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M854 472L855 473L854 472M886 472L887 473L886 472M957 472L958 473L957 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M988 472L989 473L988 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M366 473L367 474L366 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M401 473L402 474L401 473M417 473L418 474L417 473M431 473L432 474L431 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M453 473L454 474L453 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M463 473L464 474L463 473M485 473L486 474L485 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M500 473L501 474L500 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M589 473L590 474L589 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M624 473L625 474L624 473M674 473L675 474L674 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M690 473L691 474L690 473M727 473L728 474L727 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M730 473L731 474L730 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M731 473L732 474L731 473M764 473L765 474L764 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M797 473L798 474L797 473M830 473L831 474L830 473M853 473L854 474L853 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M887 473L888 474L887 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M956 473L957 474L956 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M990 473L991 474L990 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M365 474L366 475L365 474M402 474L406 478L402 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M403 474L404 475L403 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M417 474L418 475L417 474M432 474L433 475L432 474M464 474L465 475L464 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M484 474L485 475L484 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M499 474L500 475L499 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M588 474L589 475L588 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M625 474L626 475L625 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M626 474L627 475L626 474M673 474L674 475L673 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M689 474L690 475L689 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M728.667 474.333L729.333 474.667L728.667 474.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M763 474L764 475L763 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M795 474L796 475L795 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M831 474L832 475L831 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M851 474L852 475L851 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M852 474L853 475L852 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M888 474L889 475L888 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M955 474L956 475L955 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M991 474L992 475L991 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M364 475L365 476L364 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M404 475L405 476L404 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M418 475L419 476L418 475M432 475L433 476L432 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M452 475L453 476L452 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M464 475L465 476L464 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M484 475L485 476L484 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M499 475L500 476L499 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M587 475L588 476L587 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M627 475L628 476L627 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M673 475L674 476L673 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M689 475L690 476L689 475M794 475L795 476L794 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M832 475L833 476L832 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M850 475L851 476L850 475M889 475L890 476L889 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M954 475L955 476L954 475M363 476L364 477L363 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M405 476L406 477L405 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M418 476L419 477L418 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M433 476L434 477L433 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M452 476L453 477L452 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M465 476L466 477L465 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M498 476L499 477L498 476M586 476L587 477L586 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M628 476L629 477L628 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M673 476L674 477L673 476M688 476L689 477L688 476M833 476L834 477L833 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M849 476L850 477L849 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M889 476L890 477L889 476M953 476L954 477L953 476M992 476L993 477L992 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M301 477L301 478L330 478L301 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M362 477L363 478L362 477M433 477L434 478L433 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M451 477L452 478L451 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M465 477L466 478L465 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M483 477L484 478L483 477M498 477L499 478L498 477M585 477L586 478L585 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M628 477L629 478L628 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 477L689 478L688 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M793 477L794 478L793 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M834 477L835 478L834 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M848 477L849 478L848 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M890 477L891 478L890 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M952 477L953 478L952 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M993 477L994 478L993 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M1279 477L1279 480L1280 480L1279 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M352 478L353 482L354 482L352 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M361 478L362 479L361 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M406 478L407 479L406 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M419 478L420 479L419 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M434 478L435 479L434 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M451 478L452 479L451 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M466 478L467 479L466 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M483 478L484 479L483 478M497 478L498 479L497 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M584 478L585 479L584 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M629 478L630 479L629 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M672 478L673 479L672 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 478L793 479L792 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M835 478L836 479L835 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M848 478L849 479L848 478M951 478L952 479L951 478M994 478L995 479L994 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M360 479L361 480L360 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M407 479L408 480L407 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M419 479L420 480L419 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M434 479L435 480L434 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M450 479L451 480L450 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M466 479L467 480L466 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M482 479L483 480L482 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M497 479L498 480L497 479M630 479L631 480L630 479M672 479L672 482L673 482L672 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M687 479L688 480L687 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M791 479L792 480L791 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M809 479L810 480L809 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M810 479L811 480L810 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M811 479L812 480L811 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M802 489L825 489C820.642 476.565 806.788 476.834 802 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M816 479L817 480L816 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M817 479L818 480L817 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M818 479L819 480L818 479M835 479L836 480L835 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M849 479L850 480L849 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M868 479L868 480L871 480L868 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M891 479L892 480L891 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M950 479L951 480L950 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M968 479L969 480L968 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M969 479L970 480L969 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M970 479L971 480L970 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M961 489L984 489C980.067 475.796 966.013 477.636 961 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M975 479L976 480L975 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M976 479L977 480L976 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M977 479L978 480L977 479M994 479L995 480L994 479M360 480L361 481L360 480M380.667 480.333L381.333 480.667L380.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M382 480L382 481L386 481L382 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M386.667 480.333L387.333 480.667L386.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M408 480L409 481L408 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M420 480L421 481L420 480M434 480L435 481L434 480M450 480L451 481L450 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M467 480L468 481L467 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M482 480L483 481L482 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M535 480L536 481L535 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M536 480L536 481L542 481L542 504C545.011 496.825 545.674 480.318 536 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M542 480L543 481L542 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 480L558 481L557 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M558 480L559 481L558 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559 480L559 481L569 481L559 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M569.667 480.333L570.333 480.667L569.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M571 480L572 481L571 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M583 480L584 481L583 480M603.667 480.333L604.333 480.667L603.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M605 480L605 481L609 481L605 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M609.667 480.333L610.333 480.667L609.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M631 480L632 481L631 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 480L688 481L687 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M807 480L808 481L807 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M808 480L809 481L808 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M819 480L820 481L819 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M820 480L821 481L820 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M836 480L837 481L836 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M850 480L851 481L850 480M864 480L865 481L864 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M865 480L866 481L865 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M872 480L873 481L872 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M873 480L874 481L873 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M874 480L875 481L874 480M891 480L892 481L891 480M902 480L903 481L902 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M903 480L903 481L909 481L909 505C912.038 497.761 912.779 480.321 903 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M909 480L910 481L909 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M938 480L939 481L938 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M966 480L967 481L966 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M967 480L968 481L967 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M978 480L979 481L978 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M979 480L980 481L979 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M995 480L996 481L995 480M359 481L360 482L359 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M378 481L379 482L378 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M379 481L380 482L379 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M380.001 481.653C364.334 486.565 371.463 512.553 387.999 507.347C403.959 502.323 396.318 476.537 380.001 481.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M388 481L389 482L388 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M389 481L390 482L389 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M408 481L409 482L408 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M420 481L421 482L420 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M435 481L436 482L435 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M449 481L450 482L449 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M467 481L468 482L467 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M496 481L497 482L496 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M556 481L556 503L557 503L556 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M582 481L583 482L582 481M601 481L602 482L601 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M602 481L603 482L602 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M603.001 481.573C587.081 486.138 594.423 512.118 610.999 507.566C627.086 503.149 619.68 476.79 603.001 481.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M611 481L612 482L611 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M612 481L613 482L612 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M631 481L632 482L631 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M687 481L688 482L687 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M774.667 481.333L775.333 481.667L774.667 481.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M776 481L776 482L782 482L776 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M790 481L791 482L790 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M806 481L807 482L806 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M821 481L822 482L821 481M836 481L837 482L836 481M851 481L852 482L851 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M862 481L863 482L862 481M875 481L876 482L875 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M892 481L893 482L892 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M923 481L923 503L924 503L923 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M949 481L950 482L949 481M965 481L966 482L965 481M980 481L981 482L980 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M995 481L996 482L995 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M358 482L359 483L358 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M376 482L377 483L376 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M377 482L378 483L377 482M390 482L391 483L390 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M391 482L392 483L391 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M409 482L410 483L409 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M421 482L422 483L421 482M435 482L436 483L435 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M449 482L450 483L449 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M468 482L469 483L468 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M481 482L482 483L481 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M599 482L600 483L599 482M614 482L615 483L614 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M632 482L633 483L632 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M672 482L672 490L673 490L672 482M771 482L772 483L771 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M772 482L773 483L772 482M789 482L790 483L789 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M805 482L806 483L805 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M822 482L823 483L822 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M837 482L838 483L837 482M851 482L852 483L851 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M860 482L861 483L860 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M876 482L877 483L876 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M892.333 482.667L892.667 483.333L892.333 482.667M964 482L965 483L964 482M981 482L982 483L981 482M996 482L997 483L996 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M352 483L353 484L352 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M358 483L359 484L358 483M375 483L376 484L375 483M392 483L393 484L392 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M409 483L410 484L409 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M421 483L422 484L421 483M436 483L437 484L436 483M448 483L449 484L448 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M468 483L469 484L468 483M481 483L482 484L481 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M495 483L496 484L495 483M581 483L582 484L581 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M598 483L599 484L598 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M615 483L616 484L615 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M632 483L633 484L632 483M686 483L686 489L687 489L686 483M769 483L770 484L769 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M770 483L771 484L770 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 483L790 484L789 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M804 483L805 484L804 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M823 483L824 484L823 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M837 483L838 484L837 483M852 483L853 484L852 483M859 483L860 484L859 483M877 483L878 484L877 483M948 483L949 484L948 483M963 483L964 484L963 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M982 483L983 484L982 483M996.333 483.667L996.667 484.333L996.333 483.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M374 484L375 485L374 484M393 484L394 485L393 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M410 484L411 485L410 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M422 484L423 485L422 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M436 484L437 485L436 484M448 484L449 485L448 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M469 484L470 485L469 484M480 484L481 485L480 484M495 484L496 485L495 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M581 484L582 485L581 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M597 484L598 485L597 484M616 484L617 485L616 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M633 484L634 485L633 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M768 484L769 485L768 484M803 484L804 485L803 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M823 484L824 485L823 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M853 484L854 485L853 484M858 484L859 485L858 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M878 484L879 485L878 484M892 484L893 485L892 484M962 484L963 485L962 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M982 484L983 485L982 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M357 485L358 486L357 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M373 485L374 486L373 485M394 485L395 486L394 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M410 485L411 486L410 485M422 485L423 486L422 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M469 485L470 486L469 485M480 485L481 486L480 485M494 485L495 486L494 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M580 485L581 486L580 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M596 485L597 486L596 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M617 485L618 486L617 485M633 485L634 486L633 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M767 485L768 486L767 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M788 485L789 486L788 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M824 485L825 486L824 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M838 485L839 486L838 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M854 485L855 486L854 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M857 485L858 486L857 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M878 485L879 486L878 485M947 485L948 486L947 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M962 485L963 486L962 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M983.333 485.667L983.667 486.333L983.333 485.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M997 485L998 486L997 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M357.333 486.667L357.667 487.333L357.333 486.667M395 486L396 487L395 486M423 486L424 487L423 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M437 486L438 487L437 486M447 486L448 487L447 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M470 486L471 487L470 486M494 486L495 487L494 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M580 486L581 487L580 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M618 486L619 487L618 486M766 486L767 487L766 486M788 486L789 487L788 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M802 486L803 487L802 486M824 486L825 487L824 486M838.333 486.667L838.667 487.333L838.333 486.667M855.667 486.333L856.333 486.667L855.667 486.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M878.333 486.667L878.667 487.333L878.333 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M947.333 486.667L947.667 487.333L947.333 486.667M961 486L962 487L961 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M997.333 486.667L997.667 487.333L997.333 486.667M372 487L373 488L372 487M395 487L396 488L395 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M411 487L412 488L411 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M423 487L424 488L423 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M437 487L438 488L437 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M470 487L471 488L470 487M479 487L480 488L479 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M493 487L494 488L493 487M580 487L581 488L580 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M595 487L596 488L595 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M618 487L619 488L618 487M634 487L635 488L634 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M766 487L767 488L766 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M802 487L803 488L802 487M824 487L825 488L824 487M961 487L962 488L961 487M356 488L357 489L356 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M371 488L372 489L371 488M396 488L397 489L396 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M411.333 488.667L411.667 489.333L411.333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M438 488L439 489L438 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M446 488L447 489L446 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M471 488L472 489L471 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M479 488L480 489L479 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M493 488L494 489L493 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M579.333 488.667L579.667 489.333L579.333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M594 488L595 489L594 488M619 488L620 489L619 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M634.333 488.667L634.667 489.333L634.333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M765 488L766 489L765 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M787 488L788 489L787 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M801 488L802 489L801 488M838 488L838 494L839 494L838 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M893 488L893 521L894 521L893 488M946 488L947 489L946 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M960 488L961 489L960 488M997 488L997 491L998 491L997 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M1238 488L1240 490L1240 488L1238 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M356 489L356 492L357 492L356 489M371 489L372 490L371 489M396 489L397 490L396 489M424 489L425 490L424 489M438 489L439 490L438 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M446 489L447 490L446 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M471 489L472 490L471 489M478 489L479 490L478 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M492 489L493 490L492 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M594 489L595 490L594 489M619 489L620 490L619 489M765 489L766 490L765 489M787.333 489.667L787.667 490.333L787.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M802 489L802 490L825 490L802 489M879 489L878 492L879 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M946 489L946 492L947 492L946 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M961 489L961 490L984 490L961 489M300 490L300 491L331 491L300 490M370 490L370 497L371 497L370 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M371.333 490.667L371.667 491.333L371.333 490.667M396 490L397 491L396 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M411.333 490.667L411.667 491.333L411.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M424 490L425 491L424 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M445 490L446 491L445 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M478 490L479 491L478 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M492 490L493 491L492 490M579 490L579 499L580 499L579 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M594 490L595 491L594 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M634.333 490.667L634.667 491.333L634.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 490L672 493L673 493L672 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M687 490L688 491L687 490M765 490L766 491L765 490M878 490L879 491L878 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M300 491L300 520L301 520L300 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M301 491L301 512L302 512L303 491L301 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M330 491L330 520L331 520L330 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M397.333 491.667L397.667 492.333L397.333 491.667M425 491L426 492L425 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M439 491L440 492L439 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M445 491L444 494L445 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M472 491L473 492L472 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M477 491L478 492L477 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M620.333 491.667L620.667 492.333L620.333 491.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687.333 491.667L687.667 492.333L687.333 491.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M787 491L787 498L788 498L787 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M859 491L860 492L859 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M860.667 491.333L861.333 491.667L860.667 491.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M862 491L862 492L877 492L862 491M356 492L356 497L357 497L356 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M425 492L426 493L425 492M444 492L445 493L444 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M458 492L460 494L458 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M459 492L460 493L459 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M477 492L478 493L477 492M491 492L492 493L491 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M764 492C764 499.649 766.711 513.782 762 520L762 521C767.378 517.513 766.362 497.629 764 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M856 492L857 493L856 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M857 492L858 493L857 492M946 492L946 497L947 497L946 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M397 493L397 496L398 496L397 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M426 493L427 494L426 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M440 493L441 494L440 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M457 493L458 494L457 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M473 493L474 494L473 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M491 493L492 494L491 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M593 493L593 497L594 497L593 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M620 493L620 496L621 496L620 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M672 493L673 494L672 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M854 493L855 494L854 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M997 493L997 496L998 496L997 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M426 494L427 495L426 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M440 494L441 495L440 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M443 494L444 495L443 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M457 494L458 495L457 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M460 494L461 495L460 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M476 494L477 495L476 494M490 494L491 495L490 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 494L689 495L688 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M838 494L838 497L839 497L838 494M852 494L853 495L852 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M427 495L428 496L427 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M441 495L442 496L441 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M443 495L444 496L443 495M456 495L457 496L456 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M460 495L461 496L460 495M474 495L476 497L474 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M476 495L477 496L476 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M490 495L491 496L490 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M673 495L674 496L673 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M688 495L689 496L688 495M851 495L852 496L851 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M397.333 496.667L397.667 497.333L397.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M427 496L428 497L427 496M441 496L442 497L441 496M456 496L457 497L456 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M474 496L475 497L474 496M489 496L490 497L489 496M620.333 496.667L620.667 497.333L620.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M673 496L674 497L673 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M689 496L690 497L689 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M850 496L851 497L850 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M997.333 496.667L997.667 497.333L997.333 496.667M356 497L356 500L357 500L356 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M411.333 497.667L411.667 498.333L411.333 497.667M428 497L429 498L428 497M441.667 497.333L442.333 497.667L441.667 497.333M455 497L456 498L455 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M461 497L462 498L461 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M489 497L490 498L489 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M634 497L634 500L635 500L634 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M673 497L674 498L673 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 497L690 498L689 497M728.667 497.333L729.333 497.667L728.667 497.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M838 497L839 498L838 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M849 497L850 498L849 497M946 497L946 500L947 500L946 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M371 498L372 499L371 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M428 498L429 499L428 498M455 498L456 499L455 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M488 498L489 499L488 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M594 498L595 499L594 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M674 498L675 499L674 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M690 498L691 499L690 498M727 498L728 499L727 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M730 498L731 499L730 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M731 498L732 499L731 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M787 498L787 501L788 501L787 498M848 498L849 499L848 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M997 498L998 499L997 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M371 499L372 500L371 499M396 499L397 500L396 499M411.333 499.667L411.667 500.333L411.333 499.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M454 499L455 500L454 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M462 499L463 500L462 499M488 499L489 500L488 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M579 499L580 500L579 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M594 499L595 500L594 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M619 499L620 500L619 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M674 499L675 500L674 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M690 499L691 500L690 499M727 499L728 500L727 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M732 499L733 500L732 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M801.333 499.667L801.667 500.333L801.333 499.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M802 499L802 500L838 500C828.44 495.989 812.387 499 802 499M961 499L961 500L997 500C987.44 495.989 971.387 499 961 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M356 500L357 501L356 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M371 500L372 501L371 500M396 500L397 501L396 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M429 500L430 501L429 500M454 500L455 501L454 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M487 500L488 501L487 500M594 500L596 503L594 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M619 500L620 501L619 500M634 500L635 501L634 500M691 500L692 501L691 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M726 500L727 501L726 500M733 500L734 501L733 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M847 500L848 501L847 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M865 500L866 501L865 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M866 500L866 501L879 501L866 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M946 500L947 501L946 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M960 500L961 501L960 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M372 501L373 502L372 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M395 501L396 502L395 501M411 501L412 502L411 501M429 501L430 502L429 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M453 501L454 502L453 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M463 501L464 502L463 501M487 501L488 502L487 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M580 501L581 502L580 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M595 501L596 502L595 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M618 501L619 502L618 501M634 501L635 502L634 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M675 501L676 502L675 501M692 501L693 502L692 501M725 501L726 502L725 501M735 501L736 502L735 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M787 501L788 502L787 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M802 501L803 502L802 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M847 501L848 502L847 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M863 501L864 502L863 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M879 501L871 501.001C853.274 501.094 867.531 518.026 876.486 506.896C877.918 505.116 878.438 503.151 879 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M879 501L880 502L879 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M961 501L962 502L961 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M357 502L358 503L357 502M372 502L373 503L372 502M395 502L396 503L395 502M410.333 502.667L410.667 503.333L410.333 502.667M430 502L431 503L430 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M453 502L454 503L453 502M580 502L581 503L580 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M618 502L619 503L618 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M693 502L694 503L693 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M724 502L725 503L724 502M736 502L737 503L736 502M788 502L789 503L788 502M802 502L803 503L802 502M861 502L862 503L861 502M947 502L948 503L947 502M961 502L962 503L961 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M357 503L358 504L357 503M373 503L374 504L373 503M394 503L395 504L394 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M430 503L431 504L430 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M452 503L453 504L452 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M464 503L465 504L464 503M486 503L487 504L486 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M580 503L581 504L580 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M596 503L597 504L596 503M617 503L618 504L617 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M633 503L634 504L633 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M676 503L677 504L676 503M694 503L695 504L694 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M723 503L724 504L723 503M737 503L738 504L737 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M738 503L739 504L738 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M788 503L789 504L788 503M803 503L804 504L803 503M846 503L846 510L847 510L846 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M861 503L862 504L861 503M878 503L879 504L878 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M947 503L948 504L947 503M962 503L963 504L962 503M374 504L375 505L374 504M393 504L394 505L393 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M410 504L411 505L410 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M431 504L432 505L431 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M452 504L453 505L452 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M465 504L466 505L465 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M542 504L542 507L543 507L542 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 504L558 505L557 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M581 504L582 505L581 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M597 504L598 505L597 504M616 504L617 505L616 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M633 504L634 505L633 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M677 504L678 505L677 504M695 504L696 505L695 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M721 504L722 505L721 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M722 504L723 505L722 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M739 504L740 505L739 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M788 504L789 505L788 504M804 504L806 506L804 504M829 504L830 505L829 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M830 504L831 505L830 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M860 504L860 507L861 507L860 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M878 504L879 505L878 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M924 504L925 505L924 504M963 504L964 505L963 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M989 504L990 505L989 504M358 505L359 506L358 505M375 505L376 506L375 505M392 505L393 506L392 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M409 505L410 506L409 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M431 505L432 506L431 505M465 505L466 506L465 505M485 505L486 506L485 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M557 505L558 506L557 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M581 505L582 506L581 505M598 505L599 506L598 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M615 505L616 506L615 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M632 505L633 506L632 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M677 505L678 506L677 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M697 505L698 506L697 505M720 505L721 506L720 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M739 505L740 506L739 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 505L790 506L789 505M804 505L805 506L804 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M828 505L829 506L828 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M829 505L830 506L829 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M831 505L832 506L831 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M909.333 505.667L909.667 506.333L909.333 505.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M924 505L925 506L924 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M948 505L949 506L948 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M964 505L965 506L964 505M987 505L988 506L987 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M990 505L991 506L990 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M358 506L359 507L358 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M376 506L377 507L376 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M390 506L391 507L390 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M391 506L392 507L391 506M409 506L410 507L409 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M432 506L433 507L432 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M451 506L452 507L451 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M465 506L466 507L465 506M485 506L486 507L485 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M558 506L559 507L558 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M599 506L600 507L599 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M614 506L615 507L614 506M632 506L633 507L632 506M678 506L679 507L678 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M698 506L699 507L698 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M699 506L700 507L699 506M718 506L719 507L718 506M738 506L739 507L738 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M789 506L790 507L789 506M806 506L807 507L806 506M826 506L827 507L826 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M827 506L828 507L827 506M831 506L832 507L831 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M877 506L878 507L877 506M925 506L926 507L925 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M948 506L949 507L948 506M965 506L966 507L965 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M986 506L987 507L986 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M359 507L360 508L359 507M378 507L379 508L378 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M388 507L389 508L388 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M389 507L390 508L389 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M408 507L409 508L408 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M432 507L433 508L432 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M450 507L451 508L450 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M466 507L467 508L466 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M484 507L485 508L484 507M543.333 507.667L543.667 508.333L543.333 507.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559 507L560 508L559 507M582 507L583 508L582 507M601 507L602 508L601 507M612 507L613 508L612 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M631 507L632 508L631 507M679 507L680 508L679 507M700 507L701 508L700 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M701 507L702 508L701 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M702 507L703 508L702 507M715 507L716 508L715 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M716 507L717 508L716 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M737 507L738 508L737 507M790 507L791 508L790 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M807 507L808 508L807 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M824 507L825 508L824 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M825 507L826 508L825 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M832 507L833 508L832 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M861 507L862 508L861 507M876 507L877 508L876 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M926 507L927 508L926 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M949 507L950 508L949 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M966 507L967 508L966 507M984 507L985 508L984 507M991 507L992 508L991 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M359 508L360 509L359 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M380 508L381 509L380 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M381 508L381 509L387 509L381 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M387 508L388 509L387 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M408 508L409 509L408 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M433 508L434 509L433 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M450 508L451 509L450 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M466 508L467 509L466 508M484 508L485 509L484 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M561 508L562 509L561 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M562.667 508.333L563.333 508.667L562.667 508.333M569 508L569 509L572 509L569 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M572 508L573 509L572 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M583 508L584 509L583 508M603 508L604 509L603 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M604 508L604 509L610 509L604 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M610 508L611 509L610 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M631 508L632 509L631 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M704.667 508.333L705.333 508.667L704.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M706 508L706 509L713 509L706 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M713 508L714 509L713 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M737 508L738 509L737 508M790 508L791 509L790 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M809 508L810 509L809 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M810 508L811 509L810 508M821 508L822 509L821 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M822 508L823 509L822 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M823 508L824 509L823 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M833 508L834 509L833 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M861 508L862 509L861 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M875 508L876 509L875 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M910 508L911 509L910 508M927 508L928 509L927 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M928 508L929 509L928 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M929 508L930 509L929 508M936 508L936 509L939 509L936 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M939 508L940 509L939 508M968 508L969 509L968 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M969 508L970 509L969 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M981 508L982 509L981 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M982 508L983 509L982 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M992 508L993 509L992 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M360 509L361 510L360 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M383 509L384 510L383 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M407 509L408 510L407 509M433 509L434 510L433 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M449 509L450 510L449 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M467 509L468 510L467 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M483 509L484 510L483 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M543 509L544 510L543 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M573 509L574 510L573 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M583 509L584 510L583 509M630 509L631 510L630 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M680 509L681 510L680 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M736 509L737 510L736 509M791 509L792 510L791 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M810 509L810 510L814 510L810 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M814 509L814 510L819 510L814 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M819.667 509.333L820.333 509.667L819.667 509.333M833 509L834 510L833 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M862 509L863 510L862 509M874 509L875 510L874 509M910 509L911 510L910 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M940 509L941 510L940 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M950 509L951 510L950 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M971 509L972 510L971 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M972 509L972 510L978 510L972 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M978.667 509.333L979.333 509.667L978.667 509.333M992 509L993 510L992 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M361 510L362 511L361 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M406 510L407 511L406 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M449 510L450 511L449 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M467 510L468 511L467 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M483 510L484 511L483 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M543 510L544 511L543 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M584 510L585 511L584 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M629 510L630 511L629 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M681 510L682 511L681 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M735 510L736 511L735 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M792 510L793 511L792 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M834 510L835 511L834 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M846 510L847 511L846 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M863 510L864 511L863 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M864 510L865 511L864 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M872 510L873 511L872 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M873 510L874 511L873 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M910 510L911 511L910 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M951 510L952 511L951 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M993 510L994 511L993 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M362 511L366 515L362 511M405 511L406 512L405 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M434 511L435 512L434 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M448 511L449 512L448 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M468 511L469 512L468 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M482 511L483 512L482 511M544 511L545 512L544 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M573 511L574 512L573 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M585 511L586 512L585 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M629 511L630 512L629 511M682 511L683 512L682 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M734 511L735 512L734 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M792 511L793 512L792 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M834 511L835 512L834 511M847 511L848 512L847 511M866 511L866 512L871 512L866 511M911 511L912 512L911 511M952 511L953 512L952 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M362 512L363 513L362 512M405 512L406 513L405 512M434 512L435 513L434 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M448 512L449 513L448 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M468 512L469 513L468 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M482 512L483 513L482 512M544 512L545 513L544 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M586 512L587 513L586 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M628 512L629 513L628 512M683 512L684 513L683 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M733 512L734 513L733 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M793 512L794 513L793 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M835 512L836 513L835 512M847 512L848 513L847 512M911 512L912 513L911 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M952 512L953 513L952 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M994 512L995 513L994 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M363 513L364 514L363 513M404 513L405 514L404 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M435 513L436 514L435 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M469 513L470 514L469 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M545 513L546 514L545 513M587 513L588 514L587 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M627 513L628 514L627 513M684 513L685 514L684 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M685 513L686 514L685 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M732 513L733 514L732 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M794 513L795 514L794 513M836.333 513.667L836.667 514.333L836.333 513.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M848 513L849 514L848 513M912 513L913 514L912 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M940 513L940 516L941 516L940 513M953 513L954 514L953 513M995 513L996 514L995 513M364 514L365 515L364 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M402 514L401 516L402 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M403 514L404 515L403 514M435 514L436 515L435 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M447 514L448 515L447 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M469 514L470 515L469 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M481 514L482 515L481 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M545 514L546 515L545 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M588 514L589 515L588 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M626 514L627 515L626 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M686.667 514.333L687.333 514.667L686.667 514.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M731 514L732 515L731 514M795 514L797 516L795 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M796 514L797 515L796 514M835 514L836 515L835 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M848 514L849 515L848 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M912 514L913 515L912 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M994 514L995 515L994 514M366 515L367 516L366 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M402 515L403 516L402 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M436 515L437 516L436 515M446 515L447 516L446 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M470 515L471 516L470 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M481 515L482 516L481 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M546 515L547 516L546 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M589 515L590 516L589 515M624 515L625 516L624 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M625 515L626 516L625 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 515L688 516L687 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M729 515L730 516L729 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M834 515L835 516L834 515M849 515L850 516L849 515M913 515L914 516L913 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M956 515L957 516L956 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M993 515L994 516L993 515M367 516L368 517L367 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M400 516L401 517L400 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M436 516L437 517L436 516M446 516L447 517L446 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M470 516L471 517L470 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M480 516L481 517L480 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M547 516L548 517L547 516M590 516L591 517L590 516M623 516L624 517L623 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 516L689 517L688 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M689 516L690 517L689 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M728 516L729 517L728 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M798 516L799 517L798 516M832 516L833 517L832 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M833 516L834 517L833 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M850 516L851 517L850 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M879 516L880 517L879 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M880 516L880 520L881 520L880 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M914 516L915 517L914 516M957 516L958 517L957 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M992 516L993 517L992 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M368 517L369 518L368 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M369 517L370 518L369 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M399 517L400 518L399 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M437 517L438 518L437 517M445 517L446 518L445 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M471 517L472 518L471 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M480 517L481 518L480 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M548 517L549 518L548 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M573 517L573 520L574 520L573 517M591 517L592 518L591 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M592 517L593 518L592 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M622 517L623 518L622 517M690 517L691 518L690 517M726 517L727 518L726 517M799 517L800 518L799 517M831 517L832 518L831 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M851 517L852 518L851 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M878 517L879 518L878 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M915 517L916 518L915 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M958 517L959 518L958 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M990 517L991 518L990 517M370 518L371 519L370 518M397 518L398 519L397 518M437 518L438 519L437 518M445 518L446 519L445 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M471 518L472 519L471 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M479 518L480 519L479 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M549 518L550 519L549 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M550 518L551 519L550 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M593 518L594 519L593 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M594 518L595 519L594 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M620 518L621 519L620 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M691 518C671.022 532.094 714.681 563.757 720 544C714.742 541.313 707.894 532.887 707 527L704 524L697 520L694 519L691 520L691 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M692 518L693 519L692 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M693 518L694 519L693 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M724 518L725 519L724 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M800 518L801 519L800 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M801 518L802 519L801 518M829 518L830 519L829 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M830 518L831 519L830 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M852 518L853 519L852 518M876 518L877 519L876 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M916 518L917 519L916 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M917 518L918 519L917 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M960 518L961 519L960 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M988 518L989 519L988 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M989 518L990 519L989 518M345 519L346 520L345 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M372 519L373 520L372 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M373 519L374 520L373 519M394 519L395 520L394 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M395 519L396 520L395 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M396 519L397 520L396 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M444 519L445 520L444 519M472 519L473 520L472 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M479 519L480 520L479 519M551 519L552 520L551 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M552 519L553 520L552 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M595 519L596 520L595 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M596 519L597 520L596 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M618 519L619 520L618 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M691.667 519.333L692.333 519.667L691.667 519.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M694 519L695 520L694 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M695 519L696 520L695 519M721 519L722 520L721 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M722 519L723 520L722 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M802 519L803 520L802 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M803 519L804 520L803 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M826 519L827 520L826 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M827 519L828 520L827 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M828 519L829 520L828 519M853 519L854 520L853 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M854 519L855 520L854 519M874 519L875 520L874 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M875 519L876 520L875 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M918 519L919 520L918 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M919 519L920 520L919 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M962 519L963 520L962 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M963 519L964 520L963 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M986 519L987 520L986 519M286 520L287 521L286 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M287 520L287 521L300 521L287 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M330 520L331 521L330 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M331 520L331 521L344 521L331 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M344 520L345 521L344 520M374 520L375 521L374 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M375.667 520.333L376.333 520.667L375.667 520.333M391 520L392 521L391 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M392.667 520.333L393.333 520.667L392.667 520.333M438 520L439 521L438 520M444 520L445 521L444 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M472 520L473 521L472 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M478 520L474 521L474 522L479 521L478 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M553 520L554 521L553 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M554 520L555 521L554 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M555 520L556 521L555 520M571.667 520.333L572.333 520.667L571.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M597 520L598 521L597 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M598 520L599 521L598 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M599 520L600 521L599 520M614 520L615 521L614 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M615 520L616 521L615 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M616 520L617 521L616 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M694.667 520.333L695.333 520.667L694.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M697 520L698 521L697 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M698.667 520.333L699.333 520.667L698.667 520.333M717.667 520.333L718.333 520.667L717.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M719 520L720 521L719 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M750 520L751 521L750 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M751 520L751 521L761 521L751 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M761 520L762 521L761 520M764 520L765 521L764 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M765 520L766 521L765 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M805 520L806 521L805 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M806.667 520.333L807.333 520.667L806.667 520.333M823 520L824 521L823 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M824 520L825 521L824 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M825 520L826 521L825 520M855 520L856 521L855 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M856.667 520.333L857.333 520.667L856.667 520.333M871 520L872 521L871 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M872 520L873 521L872 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M873 520L874 521L873 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M880 520L880 521L893 521L880 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M920 520L921 521L920 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M921 520L922 521L921 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M922 520L923 521L922 520M938.667 520.333L939.333 520.667L938.667 520.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M964 520L965 521L964 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M965 520L966 521L965 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M966 520L967 521L966 520M982 520L983 521L982 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M983 520L984 521L983 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M984 520L985 521L984 520M377 521L378 522L377 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M378 521L378 522L381 522L378 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M381 521L381 522L387 522L381 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M387 521L387 522L390 522L387 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M390 521L391 522L390 521M438 521L439 522L438 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M439 521L439 522L444 522L439 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M473 521L474 522L473 521M478 521L479 522L478 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M556 521L557 522L556 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 521L557 522L560 522L557 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M560 521L560 522L567 522L560 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M567 521L567 522L570 522L567 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M570 521L571 522L570 521M600.667 521.333L601.333 521.667L600.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M602.667 521.333L603.333 521.667L602.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M604 521L604 522L610 522L604 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M610 521L610 522L613 522L610 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M613 521L614 522L613 521M699.667 521.333L700.333 521.667L699.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M701 521L701 522L704 522L701 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M704 521L704 522L712 522L704 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M712 521L712 522L715 522L712 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M715.667 521.333L716.333 521.667L715.667 521.333M808 521L809 522L808 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M809.667 521.333L810.333 521.667L809.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M811 521L811 522L819 522L811 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M819 521L819 522L822 522L819 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M822 521L823 522L822 521M858 521L859 522L858 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M859.667 521.333L860.333 521.667L859.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M861 521L861 522L868 522L861 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M868.667 521.333L869.333 521.667L868.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M870 521L871 522L870 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M924 521L924 522L927 522L924 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M927 521L927 522L934 522L927 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M934.667 521.333L935.333 521.667L934.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M936.667 521.333L937.333 521.667L936.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M968 521L968 522L971 522L968 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M971 521L971 522L978 522L971 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M978.667 521.333L979.333 521.667L978.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M980 521L981 522L980 521M335 523L336 524L335 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M274 525L275 526L274 525M280 525L281 526L280 525M282 526L283 527L282 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M332 527L333 528L332 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M703 527L704 528L703 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M1128 547L1128 548L1143 565L1168 577L1168 581L1176 577L1176 582L1177 582L1176 568C1171.46 565.68 1168.98 561.323 1164.87 558.467C1154.58 551.322 1140.49 546.057 1128 547M336 555L332 576L338 576L336 597L344 597L344 600L368 603L369 607L373 602L374 602L377 609L376 623L377 623L381 619L383 614L382 618L383 618C384.996 615.569 386.288 615.204 383 613L389 610L383 609L382 609L380 611L380 607L379 607L377 609L376 601L379 601L380 596L381 596L380 599L384 597L384 596L380 592L377 593L375 575L366.437 566.815L352 563C350.263 557.058 341.471 555.004 336 555M353 557C353.654 560.054 355.007 559.936 358 560L353 557M360 559L361 560L360 559M694 566L695 567L694 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M695 566L695 567L698 567L695 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M698 566L699 567L698 566M765.667 566.333L766.333 566.667L765.667 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M767 566L767 567L770 567L767 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M770 566L771 567L770 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M661 567L662 568L661 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M661 646L662 646L662 568L672 568C659.511 562.76 661 575.785 661 584L661 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M672 567L673 568L672 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M673.667 567.333L674.333 567.667L673.667 567.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M675 567L676 568L675 567M691 567L692 568L691 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M692 567L693 568L692 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M693.044 567.746C682.968 571.72 689.826 587.215 699.956 582.987C709.993 578.797 703.067 563.794 693.044 567.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M699 567L700 568L699 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M700 567L701 568L700 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M701 567L702 568L701 567M763 567L764 568L763 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M764 567L765 568L764 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M765.019 567.746C755.428 571.436 760.964 587.061 770.985 583.254C781.514 579.253 775.075 563.878 765.019 567.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M771 567L772 568L771 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M772 567L773 568L772 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M662 568L662 646L675 646L675 568L662 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M675 568L675 646L676 646L676 592L675 568M690 568L691 569L690 568M702 568L703 569L702 568M762 568L763 569L762 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M773 568L776 571L773 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M774 568L775 569L774 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 569L690 570L689 569M703 569L704 570L703 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M761 569L762 570L761 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M775 569L776 570L775 569M688 570L689 571L688 570M704 570L705 571L704 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M760 570L761 571L760 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M688 571L689 572L688 571M704 571L705 572L704 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M759 571L760 572L759 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M776 571L777 572L776 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M687 572L688 573L687 572M705 572L706 573L705 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M759 572L760 573L759 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M776 572L777 573L776 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687 573L688 574L687 573M705 573L705 578L706 578L705 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M759 573L759 578L760 578L759 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M777 573L777 577L778 577L777 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M687.333 574.667L687.667 575.333L687.333 574.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M494 575L494 576L498 576L494 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M498 575L498 576L501 576L498 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M501 575L501 576L504 576L501 575M489 576L490 577L489 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M490.667 576.333L491.333 576.667L490.667 576.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M492 576L493 577L492 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M521 623L520 623C516.644 626.354 513.343 630.335 509 632.428C505.682 634.027 501.648 634.651 498 634.319C464.248 631.249 478.479 577.285 508 590.363C512.798 592.489 516.35 596.36 520 600C539.157 589.084 515.179 576.633 502 576.039C462.346 574.255 447.905 631.519 487 645.099C497.81 648.854 511.667 647.522 520.985 640.699C523.747 638.677 529.647 634.263 528.542 630.184C527.748 627.251 523.19 624.87 521 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M506 576L507 577L506 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M507.667 576.333L508.333 576.667L507.667 576.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M509 576L510 577L509 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M687.333 576.667L687.667 577.333L687.333 576.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M486 577L487 578L486 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M487 577L488 578L487 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M488 577L489 578L488 577M510 577L511 578L510 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M511 577L512 578L511 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M512 577L513 578L512 577M484 578L485 579L484 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M485 578L486 579L485 578M513 578L514 579L513 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M514 578L515 579L514 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M687 578L688 579L687 578M705 578L706 579L705 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M759 578L760 579L759 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M776 578L777 579L776 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M482 579L483 580L482 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M483 579L484 580L483 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M516 579L517 580L516 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M688 579L689 580L688 579M704 579L705 580L704 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M759 579L760 580L759 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M776 579L777 580L776 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M480 580L481 581L480 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M481 580L482 581L481 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M518 580L519 581L518 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M688 580L689 581L688 580M704 580L705 581L704 580M721 580L722 581L721 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M760 580L761 581L760 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M775 580L776 581L775 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M479 581L480 582L479 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M519 581L520 582L519 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M520 581L521 582L520 581M689 581L690 582L689 581M703 581L704 582L703 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M720 581L721 582L720 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M720 594L712 594L712 606L713 606L713 595C722.006 594.893 721 589.57 721 582L734 582C722.509 577.178 720 584.323 720 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M734 581L734 594L735 594L734 581M761 581L762 582L761 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M774 581L775 582L774 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M477 582L478 583L477 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M478 582L479 583L478 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M521 582L522 583L521 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M690 582L691 583L690 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M691 582L692 583L691 582M701 582L702 583L701 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M702 582L703 583L702 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M721 582C721 589.143 721.584 594.72 713 595L713 606L721 606C721 622.27 716.684 645.381 739 646.911C742.747 647.167 746.33 646.681 750 646L750 635C730.927 634.998 734 621.066 734 606L749 606L749 595C737.383 595 734 594.267 734 582L721 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M762 582L763 583L762 582M773 582L774 583L773 582M476 583L477 584L476 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M522 583L523 584L522 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M692 583L693 584L692 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M693 583L694 584L693 583M699 583L700 584L699 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M700 583L701 584L700 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M763 583L764 584L763 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M764 583L765 584L764 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M771 583L772 584L771 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M772 583L773 584L772 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M475 584L476 585L475 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M523 584L524 585L523 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M695 584L695 585L698 585L695 584M767 584L767 585L770 585L767 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M474 585L475 586L474 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M524 585L526 587L524 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M525 585L526 586L525 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M473 586L474 587L473 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M1166 586L1168 588L1166 586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M472 587L473 588L472 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M526 587L527 588L526 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M471 588L472 589L471 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M498 588L498 589L502 589L498 588M527 588L528 589L527 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M470 589L471 590L470 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M493 589L494 590L493 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M494.667 589.333L495.333 589.667L494.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M496.667 589.333L497.333 589.667L496.667 589.333M502.667 589.333L503.333 589.667L502.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M504.667 589.333L505.333 589.667L504.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M506 589L507 590L506 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M528 589L529 590L528 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M469 590L470 591L469 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M490 590L491 591L490 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M491 590L492 591L491 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M492 590L493 591L492 590M507 590L508 591L507 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M508 590L509 591L508 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M529 590L530 591L529 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M469 591L470 592L469 591M488 591L489 592L488 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M489 591L490 592L489 591M510 591L511 592L510 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M529 591L530 592L529 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M399 592L400 593L399 592M401 592L402 593L401 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M468 592L469 593L468 592M487 592L488 593L487 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M511 592L512 593L511 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M512 592L513 593L512 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M530 592L531 593L530 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M376 593L377 594L376 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M385 593L386 594L385 593M393.667 593.333L394.333 593.667L393.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M395.667 593.333L396.333 593.667L395.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M397 593L397 594L406 594L397 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M406.667 593.333L407.333 593.667L406.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M408 593L409 594L408 593M467 593L468 594L467 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M486 593L487 594L486 593M513 593L514 594L513 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M529 593L530 594L529 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M530 593L531 594L530 593M558 593L559 594L558 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559 593L560 594L559 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M560 593L560 594L570 594L560 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M570.667 593.333L571.333 593.667L570.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M572 593L573 594L572 593M618 593L619 594L618 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M619.667 593.333L620.333 593.667L619.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M621 593L621 594L630 594L621 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M630.667 593.333L631.333 593.667L630.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M632 593L633 594L632 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M807 593L807 594L810 594L807 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M810 593L810 594L819 594L810 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M819 593L820 594L819 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M820 593L821 594L820 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M875.667 593.333L876.333 593.667L875.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M877 593L877 594L885 594L877 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M885.667 593.333L886.333 593.667L885.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M887 593L888 594L887 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M378.667 594.333L379.333 594.667L378.667 594.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M390 594L391 595L390 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M391 594L392 595L391 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M392 594L393 595L392 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M385 612C395.192 607.339 407.378 599.584 410 617C401.47 617 390.388 615.38 383.019 620.653C374.051 627.07 375.6 641.413 386.004 645.437C395.387 649.066 402.38 645.132 411 642L411 646L423 646C423 632.018 428.024 606.62 414.907 597.249C403.569 589.149 372.037 594.7 385 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M409 594L410 595L409 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M410 594L411 595L410 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M411 594L412 595L411 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M467 594L468 595L467 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M485 594L486 595L485 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M514 594L515 595L514 594M528 594L529 595L528 594M555 594L556 595L555 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M556 594L557 595L556 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M557 594.529C523.268 602.327 538.894 653.919 572 646.319C608.007 638.054 592.229 586.386 557 594.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M573 594L574 595L573 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M574.667 594.333L575.333 594.667L574.667 594.333M615 594L616 595L615 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M616.667 594.333L617.333 594.667L616.667 594.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M610 612L611 612C619.382 604.373 633.17 601.833 634 617C625.809 617 615.325 615.481 608.015 620.008C598.717 625.768 599.601 639.675 609.004 644.86C617.537 649.566 627.832 646.446 635 641L635 646L647 646C647 632.322 652.314 605.697 638.96 596.995C627.932 589.808 594.51 595.611 610 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M633 594L634 595L633 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M634 594L635 595L634 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M635 594L636 595L635 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M689 594L690 595L689 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M689 646L690 646L690 595L703 595L703 624C705.262 618.61 706.037 601.684 703.397 596.318C701.754 592.979 692.234 592.817 690.028 595.603C687.699 598.543 689 605.469 689 609L689 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M703 594L704 595L703 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M735 594L735 595L749 595L735 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M749 594L750 595L749 594M760 594L761 595L760 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M761 594L761 595L775 595L761 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M775 594L776 595L775 594M803 594L804 595L803 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M804 594L805 595L804 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M805 594L806 595L805 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M806 594.529C772.171 602.336 787.518 654.275 821 646.1C856.278 637.487 840.792 586.5 806 594.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M822 594L823 595L822 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M823 594L824 595L823 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M824 594L825 595L824 594M852 594L852 633L853.603 645.972L867 647L867 646L853 646L853 611L852 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M853 594L853 595L866 595L853 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M871 594L872 595L871 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M872 594L873 595L872 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M873 594L874 595L873 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M866 599L866 595L853 595L853 646L867 645C866.396 636.094 864.354 620.257 867.858 612.04C870.861 604.999 879.95 604.119 884.486 610.058C890.526 617.966 887 636.454 887 646L900 646C900 626.434 906.623 591.289 877 594.104C872.696 594.513 869.351 596.418 866 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M888 594L889 595L888 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M889 594L890 595L889 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M388 595L389 596L388 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M389 595L390 596L389 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M412 595L413 596L412 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M413 595L414 596L413 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M466 595L467 596L466 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M484 595L485 596L484 595M515 595L516 596L515 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M526 595L527 596L526 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M527 595L528 596L527 595M552 595L553 596L552 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M553 595L554 596L553 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M576 595L577 596L576 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M577 595L578 596L577 595M613 595L614 596L613 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M614 595L615 596L614 595M636 595L637 596L636 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M637 595L638 596L637 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M690 595L690 646L703 646L703 595L690 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M749 595L749 600L750 600L749 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbfefe",
      stroke: "none"
    },
    d: "M761 595L761 631L762.028 644.397L775 646L775 595L761 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M775 595L775 644L776 644C776 630.212 780.309 607.652 775 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M801 595L802 596L801 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M802 595L803 596L802 595M825 595L826 596L825 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M826 595L827 596L826 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M870 595L871 596L870 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M871 595L872 596L871 595M890 595L891 596L890 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M891 595L892 596L891 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M386 596L387 597L386 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M387 596L388 597L387 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M414 596L415 597L414 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M466 596L467 597L466 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M483 596L484 597L483 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M516 596L517 597L516 596M525 596L526 597L525 596M551 596L552 597L551 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M578 596L579 597L578 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M579 596L580 597L579 596M611 596L612 597L611 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M638 596L639 597L638 596M800 596L801 597L800 596M827 596L828 597L827 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M828 596L829 597L828 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M865.333 596.667L865.667 597.333L865.333 596.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M868 596L869 597L868 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M892 596L893 597L892 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M385 597L386 598L385 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M415 597L417 599L415 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M416 597L417 598L416 597M465 597L466 598L465 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M482 597L483 598L482 597M517 597L518 598L517 597M524 597L525 598L524 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M549 597L550 598L549 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M580 597L581 598L580 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M581 597L582 598L581 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M609 597L610 598L609 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M610 597L611 598L610 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M640 597L641 598L640 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M798 597L799 598L798 597M829 597L830 598L829 597M867 597L868 598L867 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M894 597L895 598L894 597M383 598L384 599L383 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M384 598L385 599L384 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M417 598L418 599L417 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M465 598L466 599L465 598M481 598L482 599L481 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M518 598L519 599L518 598M522 598L523 599L522 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M523 598L524 599L523 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M548 598L549 599L548 598M582 598L583 599L582 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M608 598L609 599L608 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M641 598L642 599L641 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M797 598L798 599L797 598M830 598L831 599L830 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M831 598L832 599L831 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M866 598L867 599L866 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M895 598L896 599L895 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M382 599L383 600L382 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M418 599L420 601L418 599M481 599L482 600L481 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M519 599L520 600L519 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M521 599L522 600L521 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M547 599L548 600L547 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M583 599L584 600L583 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M606 599L607 600L606 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M607 599L608 600L607 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M642 599L643 600L642 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M795 599L796 600L795 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M832 599L833 600L832 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M895 599L896 600L895 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M381 600L382 601L381 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M418 600L419 601L418 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M464.333 600.667L464.667 601.333L464.333 600.667M480 600L481 601L480 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M519.667 600.333L520.333 600.667L519.667 600.333M545 600L544 602L545 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M546 600L547 601L546 600M584 600L585 601L584 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M605 600L606 601L605 600M643 600L644 601L643 600M749 600L749 603L750 603L749 600M794 600L795 601L794 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M833 600L834 601L833 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M896 600L897 601L896 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M380 601L381 602L380 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M419 601L420 602L419 601M479 601L480 602L479 601M545 601L546 602L545 601M585 601L586 602L585 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M604 601L605 602L604 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M643 601L644 602L643 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M793 601L794 602L793 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M834 601L835 602L834 601M897 601L898 602L897 601M379 602L380 603L379 602M420 602L421 603L420 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M464 602L465 603L464 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M479 602L480 603L479 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M544 602L545 603L544 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M586 602L587 603L586 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M603 602L604 603L603 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M644 602L645 603L644 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M792 602L793 603L792 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M835 602L836 603L835 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M897 602L898 603L897 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M378 603L379 604L378 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M420 603L421 604L420 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M463.333 603.667L463.667 604.333L463.333 603.667M479 603L480 604L479 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M543 603L544 604L543 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M587 603L588 604L587 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M603.333 603.667L603.667 604.333L603.333 603.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M645 603L646 604L645 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M749 603L750 604L749 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M791 603L792 604L791 603M836 603L837 604L836 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M898 603L899 604L898 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M378 604L379 605L378 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M421 604L422 605L421 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M478 604L479 605L478 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M542 604L543 605L542 604M588 604L589 605L588 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M645 604L646 605L645 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M749 604L750 605L749 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M791 604L792 605L791 604M836 604L837 605L836 604M898 604L899 605L898 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M379 605L380 606L379 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M396 605L397 606L396 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M397 605L397 606L402 606L397 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M402 605L403 606L402 605M421 605L422 606L421 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M463.333 605.667L463.667 606.333L463.333 605.667M478.333 605.667L478.667 606.333L478.333 605.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M541 605L542 606L541 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M588 605L590 607L588 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M589 605L590 606L589 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M604 605L605 606L604 605M620.667 605.333L621.333 605.667L620.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M622 605L622 606L626 606L622 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M626.667 605.333L627.333 605.667L626.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M646 605L647 606L646 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M749 605L750 606L749 605M790 605L791 606L790 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M837 605L838 606L837 605M876.667 605.333L877.333 605.667L876.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M899 605L900 606L899 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M376 606L377 607L376 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M380 606L382 608L380 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M393 606L394 607L393 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M394 606L395 607L394 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M395 606L396 607L395 606M403 606L404 607L403 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M404 606L405 607L404 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M405 606L407 608L405 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M422 606L423 607L422 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M541 606L542 607L541 606M560 606L561 607L560 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M561.667 606.333L562.333 606.667L561.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M563.667 606.333L564.333 606.667L563.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M565 606.741C548.621 606.985 548.802 633.519 565 633.802C581.984 634.098 582.332 606.482 565 606.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M566.667 606.333L567.333 606.667L566.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M568 606L569 607L568 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M569 606L570 607L569 606M617 606L618 607L617 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M618 606L619 607L618 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M619 606L620 607L619 606M628 606L629 607L628 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M629 606L630 607L629 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M646 606L647 607L646 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M712 606L712 607L720 607L712 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M720 606L721 607L720 606M734 606L735 607L734 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M735 606L735 607L749 607L735 606M789 606L790 607L789 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M809 606L810 607L809 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M810.667 606.333L811.333 606.667L810.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M812 606L813 607L812 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M813 606.642C796.324 608.055 797.954 635.096 815 633.775C831.787 632.474 829.808 605.217 813 606.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M815.667 606.333L816.333 606.667L815.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M817 606L818 607L817 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M818 606L819 607L818 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M838 606L839 607L838 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M872 606L873 607L872 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M873 606L874 607L873 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M874 606L875 607L874 606M879 606L880 607L879 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M880 606L881 607L880 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M881 606L882 607L881 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M899 606L900 607L899 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M380 607L380 611L381 611L380 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M391 607L392 608L391 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M392 607L393 608L392 607M405 607L406 608L405 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M422 607L423 608L422 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M463 607L463 617L464 617L463 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M478.333 607.667L478.667 608.333L478.333 607.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M540 607L541 608L540 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M558 607L559 608L558 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M559 607L560 608L559 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M570 607L571 608L570 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M571 607L572 608L571 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M590 607L591 608L590 607M605 607L606 608L605 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M616 607L617 608L616 607M630 607L631 608L630 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M646 607L647 608L646 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M720 607L721 608L720 607M734 607L734 628L735 628L734 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 607L790 608L789 607M807 607L808 608L807 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M808 607L809 608L808 607M819 607L820 608L819 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M820 607L821 608L820 607M838 607L839 608L838 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M871 607L872 608L871 607M882 607L883 608L882 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M899 607L900 608L899 607M382 608L383 609L382 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M390 608L391 609L390 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M407 608L408 609L407 608M422.333 608.667L422.667 609.333L422.333 608.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 608L558 609L557 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M572 608L573 609L572 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M573 608L574 609L573 608M590 608L591 609L590 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M606 608L607 609L606 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M614 608L615 609L614 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M631 608L632 609L631 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M720 608L720 630L721 630L720 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M788 608L789 609L788 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M806 608L807 609L806 608M821 608L822 609L821 608M839 608L840 609L839 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M869 608L870 609L869 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M870 608L871 609L870 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M883 608L884 609L883 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M900.333 608.667L900.667 609.333L900.333 608.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M383 609L384 610L383 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M389 609L390 610L389 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M407 609L408 610L407 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M539 609L540 610L539 609M556 609L557 610L556 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M574 609L575 610L574 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M591 609L592 610L591 609M607 609L608 610L607 609M613 609L614 610L613 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M632 609L633 610L632 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M647 609L648 610L647 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M788 609L789 610L788 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M805 609L806 610L805 609M822 609L823 610L822 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M839 609L840 610L839 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M869 609L870 610L869 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M884 609L885 610L884 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M377 610L378 611L377 610M382 610L380 614L381 614L384 612L384 611L382 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M408 610L409 611L408 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M423.333 610.667L423.667 611.333L423.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M477 610L478 611L477 610M539 610L540 611L539 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M555 610L556 611L555 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M575 610L576 611L575 610M591 610L592 611L591 610M608 610L609 611L608 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M612 610L613 611L612 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M632 610L633 611L632 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M647 610L647 613L648 613L647 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M787 610L788 611L787 610M804 610L805 611L804 610M823 610L824 611L823 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M840 610L841 611L840 610M868 610L869 611L868 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M885 610L886 611L885 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M900 610L900 614L901 614L900 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M408.333 611.667L408.667 612.333L408.333 611.667M538 611L539 612L538 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M554 611L555 612L554 611M609 611L610 612L609 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M611 611L612 612L611 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M633.333 611.667L633.667 612.333L633.333 611.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M787 611L788 612L787 611M803 611L804 612L803 611M824 611L825 612L824 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M840 611L841 612L840 611M867 611L868 612L867 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M885 611L886 612L885 611M423 612L423 646L424 646L423 612M538 612L539 613L538 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M554 612L555 613L554 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M576 612L577 613L576 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M592 612L593 613L592 612M609 612L610 613L609 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M610 612L611 613L610 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M787 612L788 613L787 612M802 612L803 613L802 612M825 612L826 613L825 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M867 612L868 613L867 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M308 616L312 613L308 616M377 613L379 615L377 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M409 613L409 617L410 617L409 613M538 613L539 614L538 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M553 613L554 614L553 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M577 613L578 614L577 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M592 613L593 614L592 613M633 613C630.261 617.224 624.57 616 620 616L620 617C623.571 617 634.287 618.731 633 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M647 613L647 644L648 644L647 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M802 613L803 614L802 613M825 613L826 614L825 613M841 613L842 614L841 613M867 613L867 616L868 616L867 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M886 613L887 614L886 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M387 614L389 616L387 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M577 614L578 615L577 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M592.333 614.667L592.667 615.333L592.333 614.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M786 614L787 615L786 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M801 614L802 615L801 614M826 614L827 615L826 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M841.333 614.667L841.667 615.333L841.333 614.667M886 614L886 646L887 646L886 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M900 614L900 630L901 630L900 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M384 615L385 616L384 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M478.333 615.667L478.667 616.333L478.333 615.667M537 615L538 616L537 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M552 615L553 616L552 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M786.333 615.667L786.667 616.333L786.333 615.667M801 615L802 616L801 615M826 615L827 616L826 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M391 616L391 617L396 617L391 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M396 616L396 617L409 617L396 616M537 616L537 624L538 624L537 616M552.333 616.667L552.667 617.333L552.333 616.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M578 616L579 617L578 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M593 616L593 624L594 624L593 616M616 616L616 617L620 617L616 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M633 616L634 617L633 616M841 616L841 625L842 625L841 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M387 617L388 618L387 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M388 617L389 618L388 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M389 617L389 618L392 618L389 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M463.333 617.667L463.667 618.333L463.333 617.667M478 617L479 618L478 617M578.333 617.667L578.667 618.333L578.333 617.667M612.667 617.333L613.333 617.667L612.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M614.667 617.333L615.333 617.667L614.667 617.333M786 617L786 623L787 623L786 617M800 617L800 623L801 623L800 617M827.333 617.667L827.667 618.333L827.333 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M384 618L385 619L384 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M385 618L386 619L385 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M386 618L387 619L386 618M478 618L479 619L478 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M552 618L553 619L552 618M609 618L610 619L609 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M610 618L611 619L610 618M383 619L384 620L383 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M384 619L385 620L384 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M463 619L464 620L463 619M479 619L480 620L479 619M578.333 619.667L578.667 620.333L578.333 619.667M607 619L608 620L607 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M608 619L609 620L608 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M827.333 619.667L827.667 620.333L827.333 619.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M381 620L378 624L381 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M382 620L383 621L382 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M479 620L480 621L479 620M606 620L607 621L606 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M381 621L382 622L381 621M464 621L465 622L464 621M479 621L480 622L479 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M552.333 621.667L552.667 622.333L552.333 621.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M578 621L578 624L579 624L578 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M605 621L606 622L605 621M827 621L827 624L828 624L827 621M380 622L381 623L380 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M464 622L465 623L464 622M480 622L481 623L480 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M519.667 622.333L520.333 622.667L519.667 622.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M604 622L605 623L604 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M374 623L372 626L374 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M379 623L380 624L379 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M464 623L465 624L464 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M480 623L481 624L480 623M519 623L520 624L519 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M521 623L522 624L521 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M552.333 623.667L552.667 624.333L552.333 623.667M603 623L604 624L603 623M786 623L786 626L787 626L786 623M378 624L379 625L378 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M465 624L466 625L465 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M481 624L482 625L481 624M518 624L519 625L518 624M522 624L523 625L522 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M537.333 624.667L537.667 625.333L537.333 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M578 624L579 625L578 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M602 624L603 625L602 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M703 624L703 641L704 641L703 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M801 624L802 625L801 624M826 624L827 625L826 624M377 625L378 626L377 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M465 625L466 626L465 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M482 625L487 630L482 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M517 625L518 626L517 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M523 625L524 626L523 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M524 625L525 626L524 625M577 625L578 626L577 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M592.333 625.667L592.667 626.333L592.333 625.667M602 625L603 626L602 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M801 625L802 626L801 625M826 625L827 626L826 625M841 625L842 626L841 625M377 626L378 627L377 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M394 626L395 627L394 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M395 626L396 627L395 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M396 626L396 627L408 627L396 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M408 626L409 627L408 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M409.333 626.667L409.667 627.333L409.333 626.667M466 626L467 627L466 626M482 626L483 627L482 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M516 626L517 627L516 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M525 626L526 627L525 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M538 626L539 627L538 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M553 626L554 627L553 626M577 626L578 627L577 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M601 626L602 627L601 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M618 626L619 627L618 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M619.667 626.333L620.333 626.667L619.667 626.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M621 626L621 627L633 627L621 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M633 626L634 627L633 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M786 626L787 627L786 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M826 626L827 627L826 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M841 626L842 627L841 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M377 627L378 628L377 627M392 627L391 629L392 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M393 627L394 628L393 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M409 627L401 627.001C384.793 627.086 396.89 641.757 405.697 633.568C407.595 631.803 408.252 629.38 409 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M466 627L467 628L466 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M483 627L484 628L483 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M515 627L516 628L515 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M526 627L527 628L526 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M527 627L528 628L527 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M538.333 627.667L538.667 628.333L538.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M553 627L554 628L553 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M576 627L577 628L576 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M592 627L593 628L592 627M601 627L602 628L601 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M617 627L616 629L617 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M633 627L625 627.001C606.001 627.132 628.996 646.828 633 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M633 627L634 628L633 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M787 627L788 628L787 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M802 627L803 628L802 627M825 627L826 628L825 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M376 628L377 629L376 628M408.333 628.667L408.667 629.333L408.333 628.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M467 628L468 629L467 628M484 628L485 629L484 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M514 628L515 629L514 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M528 628L529 629L528 628M554 628L555 629L554 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M576 628L577 629L576 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M592 628L593 629L592 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M601.333 628.667L601.667 629.333L601.333 628.667M633.333 628.667L633.667 629.333L633.333 628.667M734.333 628.667L734.667 629.333L734.333 628.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M787 628L788 629L787 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M824 628L825 629L824 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M825 628L826 629L825 628M840 628L841 629L840 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M376 629L376 634L377 634L376 629M391 629L392 630L391 629M467 629L468 630L467 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M485 629L486 630L485 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M513 629L514 630L513 629M529 629L531 631L529 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M530 629L531 630L530 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M539 629L540 630L539 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M555 629L556 630L555 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M575 629L576 630L575 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M591 629L592 630L591 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M615.333 629.667L615.667 630.333L615.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M787 629L788 630L787 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M803 629L804 630L803 629M824 629L825 630L824 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M840 629L841 630L840 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M391 630L391 633L392 633L391 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M408 630L409 631L408 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M468 630L469 631L468 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M487 630L488 631L487 630M512 630L513 631L512 630M539 630L540 631L539 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M556 630L557 631L556 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M574 630L575 631L574 630M591 630L592 631L591 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M632 630L633 631L632 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M720 630L720 633L721 633L720 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M735 630L736 631L735 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M788 630L789 631L788 630M804 630L805 631L804 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M823 630L824 631L823 630M900 630L900 646L901 646L900 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M468 631L469 632L468 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M488 631L489 632L488 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M489 631L490 632L489 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M510 631L511 632L510 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M511 631L512 632L511 631M529 631L530 632L529 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M539 631L540 632L539 631M557 631L558 632L557 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M573 631L574 632L573 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M590 631L591 632L590 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M615 631L616 632L615 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M632 631L633 632L632 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M735 631L736 632L735 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M788 631L789 632L788 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M805 631L806 632L805 631M822 631L823 632L822 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M839 631L840 632L839 631M407 632L408 633L407 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M469 632L470 633L469 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M490 632L491 633L490 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M491 632L492 633L491 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M507 632L508 633L507 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M508 632L509 633L508 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M509 632L510 633L509 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M529 632L530 633L529 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M540 632L541 633L540 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M558 632L559 633L558 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M559 632L560 633L559 632M571 632L572 633L571 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M572 632L573 633L572 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M590 632L591 633L590 632M615 632L616 633L615 632M631 632L632 633L631 632M736 632L737 633L736 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M789 632L790 633L789 632M806 632L807 633L806 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M807 632L808 633L807 632M820 632L821 633L820 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M839 632L840 633L839 632M1277 632L1280 636L1280 632L1277 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M391 633L392 634L391 633M406 633L407 634L406 633M470 633L471 634L470 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M492.667 633.333L493.333 633.667L492.667 633.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M494 633L495 634L494 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M495 633L496 634L495 633M504 633L505 634L504 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M505 633L506 634L505 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M506 633L507 634L506 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M528 633L529 634L528 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M540 633L541 634L540 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M560 633L561 634L560 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M561 633L562 634L561 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M568 633L569 634L568 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M569 633L570 634L569 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M570 633L571 634L570 633M589 633L590 634L589 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M600 633L601 634L600 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M615 633L616 634L615 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M630 633L631 634L630 633M720 633L721 634L720 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M737 633L738 634L737 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M738 633L739 634L738 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M789 633L790 634L789 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M808 633L809 634L808 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M809 633L810 634L809 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M810 633L811 634L810 633M817 633L818 634L817 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M818 633L819 634L818 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M819 633L820 634L819 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M838 633L839 634L838 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M376.333 634.667L376.667 635.333L376.333 634.667M392 634L393 635L392 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M405 634L406 635L405 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M471 634L473 636L471 634M498 634L498 635L502 635L498 634M527 634L526 636L527 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M541 634L542 635L541 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M564 634L564 635L567 635L564 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M589 634L590 635L589 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M601.333 634.667L601.667 635.333L601.333 634.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M616 634L617 635L616 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M629 634L630 635L629 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M721 634L722 635L721 634M739.667 634.333L740.333 634.667L739.667 634.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M741 634L741 635L749 635L741 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M749 634L750 646L751 646L749 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M750 634L751 635L750 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M790 634L791 635L790 634M812 634L812 635L816 635L812 634M837 634L838 635L837 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M393 635L394 636L393 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M403 635L404 636L403 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M404 635L405 636L404 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M471 635L472 636L471 635M527 635L528 636L527 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M542 635L544 637L542 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M588 635L589 636L588 635M617 635L618 636L617 635M628 635L629 636L628 635M721 635L722 636L721 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M790 635L791 636L790 635M837 635L838 636L837 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M377 636L378 637L377 636M394 636L395 637L394 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M395 636L396 637L395 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M396 636L396 637L401 637L396 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M401 636L402 637L401 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M402 636L403 637L402 636M473 636L474 637L473 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M526 636L527 637L526 636M542 636L543 637L542 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M587 636L588 637L587 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M601 636L602 637L601 636M619.667 636.333L620.333 636.667L619.667 636.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M621 636L622 637L621 636M623.667 636.333L624.333 636.667L623.667 636.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M625 636L626 637L625 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M626 636L627 637L626 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M721 636L722 637L721 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M791 636L792 637L791 636M836 636L837 637L836 636M377 637L378 638L377 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M400 637L401 638L400 637M474 637L475 638L474 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M525 637L526 638L525 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M543 637L544 638L543 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M586 637L587 638L586 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M601 637L602 638L601 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M625 637L626 638L625 637M722 637L723 638L722 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M792 637L793 638L792 637M835 637L836 638L835 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M377 638L378 639L377 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M475 638L476 639L475 638M523 638L522 640L523 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M524 638L525 639L524 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M544 638L545 639L544 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M586 638L587 639L586 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M602 638L603 639L602 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M722 638L723 639L722 638M793 638L794 639L793 638M834 638L835 639L834 638M378 639L379 640L378 639M476 639L477 640L476 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M523 639L524 640L523 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M545 639L546 640L545 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M585 639L586 640L585 639M602 639L603 640L602 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M723 639L724 640L723 639M794 639L795 640L794 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M833 639L834 640L833 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M378 640L380 642L378 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M379 640L380 641L379 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M477 640L478 641L477 640M521 640L522 641L521 640M546 640L547 641L546 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M583 640L584 641L583 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M584 640L585 641L584 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M603 640L604 641L603 640M795 640L796 641L795 640M832 640L833 641L832 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M478 641L479 642L478 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M479 641L480 642L479 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M520 641L521 642L520 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M547 641L549 643L547 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M548 641L549 642L548 641M582 641L583 642L582 641M604 641L605 642L604 641M634 641L635 642L634 641M703.333 641.667L703.667 642.333L703.333 641.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M724 641L725 642L724 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M796 641L797 642L796 641M831 641L832 642L831 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M380 642L381 643L380 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M408 642L409 643L408 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M409 642L410 643L409 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M410 642L410 646L411 646L410 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M480 642L481 643L480 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M481 642L482 643L481 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M518 642L519 643L518 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M519 642L520 643L519 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M549 642L550 643L549 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M581 642L582 643L581 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M605 642L606 643L605 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M633 642L634 646L635 646L633 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M725 642L726 643L725 642M797 642L798 643L797 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M798 642L799 643L798 642M829 642L830 643L829 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M830 642L831 643L830 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M866 642L867 643L866 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M377 643L378 644L377 643M381 643L382 644L381 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M407 643L408 644L407 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M482 643L483 644L482 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M516 643L517 644L516 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M517 643L518 644L517 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M550 643L551 644L550 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M579 643L580 644L579 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M580 643L581 644L580 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M606 643L607 644L606 643M631 643L632 644L631 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M632 643L633 644L632 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M703.333 643.667L703.667 644.333L703.333 643.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M726 643L727 644L726 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M727 643L728 644L727 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M799 643L800 644L799 643M828 643L829 644L828 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M382 644L383 645L382 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M383 644L384 645L383 644M405 644L406 645L405 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M406 644L407 645L406 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M483 644L484 645L483 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M484 644L485 645L484 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M485 644L486 645L485 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M514 644L515 645L514 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M515 644L516 645L515 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M552 644L553 645L552 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M553 644L554 645L553 644M577 644L578 645L577 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M578 644L579 645L578 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M607 644L608 645L607 644M630 644L631 645L630 644M647 644L648 645L647 644M728 644L729 645L728 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M775 644L776 645L775 644M800 644L801 645L800 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M801 644L802 645L801 644M826 644L827 645L826 644M384 645L385 646L384 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M385 645L386 646L385 645M403 645L404 646L403 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M404 645L405 646L404 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M405 645L406 646L405 645M486 645L487 646L486 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M487 645L488 646L487 645M511 645L512 646L511 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M512 645L513 646L512 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M513 645L514 646L513 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M554 645L555 646L554 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M555 645L556 646L555 645M575 645L576 646L575 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M576 645L577 646L576 645M608 645L609 646L608 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M609 645L610 646L609 645M628 645L629 646L628 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M629 645L630 646L629 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M647 645L648 646L647 645M703 645L704 646L703 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M730 645L731 646L730 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M761 645L762 646L761 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M775 645L776 646L775 645M803 645L804 646L803 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M823 645L824 646L823 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M824 645L825 646L824 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M866 645L867 646L866 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M377 646L378 647L377 646M386 646L387 647L386 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M387 646L388 647L387 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M388.667 646.333L389.333 646.667L388.667 646.333M400 646L401 647L400 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M401 646L402 647L401 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M402 646L403 647L402 646M410 646L411 647L410 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M411 646L412 647L411 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M412 646L412 647L423 647L412 646M489 646L490 647L489 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M490 646L491 647L490 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M491.667 646.333L492.333 646.667L491.667 646.333M506.667 646.333L507.333 646.667L506.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M508.667 646.333L509.333 646.667L508.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M510 646L511 647L510 646M556 646L557 647L556 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M557 646L558 647L557 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M558.667 646.333L559.333 646.667L558.667 646.333M571 646L572 647L571 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M572.667 646.333L573.333 646.667L572.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M574 646L575 647L574 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M611 646L612 647L611 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M612.667 646.333L613.333 646.667L612.667 646.333M624 646L625 647L624 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M625.667 646.333L626.333 646.667L625.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M634 646L634 647L648 647L634 646M663 646L663 647L675 647L663 646M689 646L689 647L703 647L689 646M732 646L733 647L732 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M733 646L734 647L733 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M734.667 646.333L735.333 646.667L734.667 646.333M747.667 646.333L748.333 646.667L747.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M749 646L750 647L749 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M750 646L751 647L750 646M761 646L761 647L775 647L761 646M805 646L806 647L805 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M806 646L807 647L806 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b8c9c8",
      stroke: "none"
    },
    d: "M807 646L808 647L807 646M819.667 646.333L820.333 646.667L819.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M821 646L822 647L821 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M822 646L823 647L822 646M887 646L887 647L901 647L887 646M389.667 647.333L390.333 647.667L389.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M391 647L391 648L398 648L391 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M398.667 647.333L399.333 647.667L398.667 647.333M493.667 647.333L494.333 647.667L493.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M495 647L495 648L504 648L495 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M504.667 647.333L505.333 647.667L504.667 647.333M560 647L560 648L563 648L560 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M563 647L563 648L568 648L563 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M568.667 647.333L569.333 647.667L568.667 647.333M614.667 647.333L615.333 647.667L614.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M616 647L616 648L622 648L616 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M622.667 647.333L623.333 647.667L622.667 647.333M736 647L736 648L739 648L736 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M739.667 647.333L740.333 647.667L739.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M741 647L742 648L741 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M742.667 647.333L743.333 647.667L742.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M744.667 647.333L745.333 647.667L744.667 647.333M810 647L810 648L814 648L810 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#849a98",
      stroke: "none"
    },
    d: "M814.667 647.333L815.333 647.667L814.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#085c4b",
      stroke: "none"
    },
    d: "M816.667 647.333L817.333 647.667L816.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#03302a",
      stroke: "none"
    },
    d: "M276 656L277 671L278 671L278 656L276 656M318.667 664.333L319.333 664.667L318.667 664.333M280 669L282 672L280 669M289 690L284 696L280 705C286.752 709.631 289.658 708.388 296 704L296 709C301.851 705.917 307.173 699.984 310 694L305 693L305 692L308 692L289 690M320 716L332 720L332 712L328 712L328 707C323.017 708.31 320.817 710.96 320 716M270 708L264 712L266 715L266 716L264 720L288 720C285.679 711.509 279.486 712 272 712L272 708L270 708z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateACoalition);
export default __webpack_public_path__ + "static/media/create_a_coalition.cd6b1fcf6ba1c65bf7da1d7eaafca7ef.svg";
export { ForwardRef as ReactComponent };